import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { Component, ViewChild, ElementRef, inject, signal, effect, untracked, HostListener, NgZone } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { firstValueFrom, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MenuComponent, GatewayView } from '../../components/menu/menu.component';
import { DemonstrativoVendasComponent } from '../demonstrativo-vendas/demonstrativo-vendas.component';
import { HomeComponent } from '../home/home.component';
import { GplTransferenciaComponent } from '../gpl-transferencia/gpl-transferencia.component';
import { GplRegrasComissaoComponent } from '../gpl-regras-comissao/gpl-regras-comissao.component';
import { DuplicarProdutoComponent } from '../duplicar-produto/duplicar-produto.component';
import { GplEdicaoProdutosComponent } from '../gpl-edicao-produtos/gpl-edicao-produtos.component';
import { ProdutosListaComponent } from '../produtos-lista/produtos-lista.component';
import { GplVendaImpressaoComponent } from '../gpl-venda-impressao/gpl-venda-impressao.component';
import { CompraImpressaoComponent } from '../compra-impressao/compra-impressao.component';
import { ImpressaoCompraSelecao } from '../compra-impressao/compra-impressao.model';
import { GplConferenciaClienteComponent } from '../gpl-conferencia-cliente/gpl-conferencia-cliente.component';
import { PedidoVendaComponent } from '../pedido-venda/pedido-venda.component';
import { GplRelatoriosComissoesComponent } from '../gpl-relatorios-comissoes/gpl-relatorios-comissoes.component';
import { GplRelatorioComissionamentoComponent } from '../gpl-relatorio-comissionamento/gpl-relatorio-comissionamento.component';
import { PedidoVendaListaComponent } from '../pedido-venda-lista/pedido-venda-lista.component';
import { PreVendaComponent } from '../pre-venda/pre-venda.component';
import { PreVendaListaComponent } from '../pre-venda-lista/pre-venda-lista.component';
import { MotivoCancelamentoComponent } from '../motivo-cancelamento/motivo-cancelamento.component';
import { ControleAcessosComponent } from '../controle-acessos/controle-acessos.component';
import { AtividadeAcessosComponent } from '../atividade-acessos/atividade-acessos.component';
import { GplManualComponent } from '../gpl-manual/gpl-manual.component';
import { EtiquetaConfigComponent } from '../etiqueta-config/etiqueta-config.component';
import { ParametroComponent } from '../parametro/parametro.component';
import { PaineisSeparacaoComponent } from '../paineis-separacao/paineis-separacao.component';
import { PaineisConferenciaComponent } from '../paineis-conferencia/paineis-conferencia.component';
import { PaineisLogisticaComponent } from '../paineis-logistica/paineis-logistica.component';
import { EstoqueSeparacaoComponent } from '../estoque-separacao/estoque-separacao.component';
import { EstoqueSeparacaoItensComponent } from '../estoque-separacao-itens/estoque-separacao-itens.component';
import { EstoqueSeparacaoItensLegadoComponent } from '../estoque-separacao-itens-legado/estoque-separacao-itens-legado.component';
import { EstoqueConferenciaComponent } from '../estoque-conferencia/estoque-conferencia.component';
import { EstoqueConferenciaItensComponent } from '../estoque-conferencia-itens/estoque-conferencia-itens.component';
import { EstoqueConferenciaItensLegadoComponent } from '../estoque-conferencia-itens-legado/estoque-conferencia-itens-legado.component';
import { EstoqueLogisticaComponent } from '../estoque-logistica/estoque-logistica.component';
import { EstoqueLogisticaItensComponent } from '../estoque-logistica-itens/estoque-logistica-itens.component';
import { ConferenciaPendenteComponent } from '../conferencia-pendente/conferencia-pendente.component';
import { ItensPendentesLegadoComponent } from '../itens-pendentes-legado/itens-pendentes-legado.component';
import { ComparacaoEstoqueComponent } from '../comparacao-estoque/comparacao-estoque.component';
import { ConferenciaPendenteItensComponent } from '../conferencia-pendente-itens/conferencia-pendente-itens.component';
import { EmpresaStateService, EmpresaOpcao } from '../../services/empresa-state.service';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';
import { EtiquetaPrintService, type EtiquetaDados, type EtiquetaImpressaoContexto } from '../../services/etiqueta-print.service';
import { AerosysGatewayService, AerosysEmpresa, AerosysOrdemServico, AerosysVenda } from '../../services/aerosys-gateway.service';
import { SerialService } from '../../services/serial.service';
import { LoteService } from '../../services/lote.service';
import { MoneyMaskDirective } from '../../directives/money-mask.directive';
import { CadastroParceiroComponent } from "../cadastro-parceiro/cadastro-parceiro.component";
import { ParceirosListaComponent } from "../parceiros-lista/parceiros-lista.component";
import { LiberacaoListaComponent } from '../liberacao-lista/liberacao-lista.component';
import { PedidoCompraComponent } from '../pedido-compra/pedido-compra.component';
import { PedidoCompraFormComponent } from '../pedido-compra-form/pedido-compra-form.component';
import { PreCompraListaComponent } from '../pre-compra-lista/pre-compra-lista.component';
import { PreCompraFormComponent } from '../pre-compra-form/pre-compra-form.component';
import { CompraListaComponent } from '../compra-lista/compra-lista.component';
import { CompraFormComponent } from '../compra-form/compra-form.component';
import { CadastroAeronaveComponent } from '../cadastro-aeronave/cadastro-aeronave.component';
import { AeronavesListaComponent } from '../aeronaves-lista/aeronaves-lista.component';
import { NotaControlTesteComponent } from '../nota-control-teste/nota-control-teste.component';
import { ConsultarIpiComponent } from '../consultar-ipi/consultar-ipi.component';
import { DownloadXmlCompraComponent } from '../download-xml-compra/download-xml-compra.component';
import { ControleCoreComponent } from '../controle-core/controle-core.component';
import { ControleFormsComponent } from '../controle-forms/controle-forms.component';
import { FabricantesComponent } from '../fabricantes/fabricantes.component';
import { ContasComponent } from '../contas/contas.component';
import { GplHoleritesComponent } from '../gpl-holerites/gpl-holerites.component';

// ── Interfaces internas ────────────────────────────────────────────────────
interface DuplicarItem {
  seq: number;
  codprod: number;
  descricao: string;
  refforn?: string;
  condicao?: string;
  qtd: number;
  selecionado: boolean;
}

interface DividirItem {
  seq: number;
  codprod: number;
  descricao: string;
  refforn?: string;
  condicao?: string;
  qtdOriginal: number;
  qtdParaMover: number;
}

interface FluxoNo {
  nunota: number;
  codemp: string;
  dtmov: string;
  status: string;
  ehRaiz: boolean;
  ehSelecionada: boolean;
  filhos: FluxoNo[];
}

interface TranspSugestao {
  codparc: number;
  nomeparc: string;
  docparc?: string;
  inscEstadual?: string;
}

interface TrpTitulo { label: string; left: number; }

// @ts-ignore
@Component({
  selector: 'app-gateway',
  standalone: true,
  imports: [LoadingIndicatorComponent,
    CommonModule,
    FormsModule,
    MenuComponent,
    HomeComponent,
    DemonstrativoVendasComponent,
    GplTransferenciaComponent,
    GplRegrasComissaoComponent,
    DuplicarProdutoComponent,
    GplEdicaoProdutosComponent,
    ProdutosListaComponent,
    GplVendaImpressaoComponent,
    CompraImpressaoComponent,
    GplConferenciaClienteComponent,
    GplRelatoriosComissoesComponent,
    GplRelatorioComissionamentoComponent,
    PedidoVendaComponent,
    PedidoVendaListaComponent,
    PreVendaComponent,
    PreVendaListaComponent,
    CadastroParceiroComponent,
    ParceirosListaComponent,
    CadastroAeronaveComponent, // TODO: ver comentário no import acima
    AeronavesListaComponent,
    NotaControlTesteComponent,
    ConsultarIpiComponent,
    DownloadXmlCompraComponent,
    LiberacaoListaComponent,
    ControleCoreComponent,
    ControleFormsComponent,
    FabricantesComponent,
    ContasComponent,
    GplHoleritesComponent,
    MotivoCancelamentoComponent,
    ControleAcessosComponent,
    AtividadeAcessosComponent,
    GplManualComponent,
    EtiquetaConfigComponent,
    ParametroComponent,
    PaineisSeparacaoComponent,
    PaineisConferenciaComponent,
    PaineisLogisticaComponent,
    EstoqueSeparacaoComponent,
    EstoqueSeparacaoItensComponent,
    EstoqueSeparacaoItensLegadoComponent,
    EstoqueConferenciaComponent,
    EstoqueConferenciaItensComponent,
    EstoqueConferenciaItensLegadoComponent,
    EstoqueLogisticaComponent,
    EstoqueLogisticaItensComponent,
    ConferenciaPendenteComponent,
    ItensPendentesLegadoComponent,
    ComparacaoEstoqueComponent,
    ConferenciaPendenteItensComponent,
    PedidoCompraComponent,
    PedidoCompraFormComponent,
    PreCompraListaComponent,
    PreCompraFormComponent,
    CompraListaComponent,
    CompraFormComponent,
    MoneyMaskDirective,
  ],
  templateUrl: './gateway.component.html',
  styleUrl: './gateway.component.css'
})
export class GatewayComponent {

  private readonly ngZone       = inject(NgZone);
  private readonly gw           = inject(SankhyaGatewayService);
  private readonly sanitizer    = inject(DomSanitizer);
  private readonly serialService = inject(SerialService);
  private readonly loteService   = inject(LoteService);
  private readonly aerosysGateway = inject(AerosysGatewayService);
  private readonly printSvc      = inject(EtiquetaPrintService);
  @ViewChild(PedidoVendaListaComponent) listaRef!: PedidoVendaListaComponent;
  @ViewChild(PedidoVendaComponent) pedidoVendaRef!: PedidoVendaComponent;
  @ViewChild(PreVendaListaComponent) preVendaListaRef!: PreVendaListaComponent;
  @ViewChild(PreVendaComponent) preVendaRef!: PreVendaComponent;

  /** true quando o usuário está no módulo Pré-Venda (handlers compartilhados com a Venda). */
  modoPreVenda = signal(false);
  /** Lista ativa conforme o módulo (Venda ou Pré-Venda). */
  private get listaAtiva(): any { return this.modoPreVenda() ? this.preVendaListaRef : this.listaRef; }
  private _vLista(): GatewayView { return this.modoPreVenda() ? 'pre-venda-lista' : 'pedido-venda-lista'; }
  private _vForm(): GatewayView { return this.modoPreVenda() ? 'pre-venda' : 'pedido-venda'; }
  @ViewChild(PedidoCompraFormComponent) pedidoCompraFormRef?: PedidoCompraFormComponent;
  @ViewChild(PreCompraFormComponent) preCompraFormRef?: PreCompraFormComponent;
  @ViewChild(CompraFormComponent) compraFormRef?: CompraFormComponent;
  /** true enquanto o Pedido de Compra está na aba Itens (menu lateral recolhido). */
  pedidoCompraAbaItens = signal(false);
  preCompraAbaItens = signal(false);
  compraAbaItens = signal(false);
  @ViewChild(EstoqueConferenciaItensComponent) conferenciaItensRef?: EstoqueConferenciaItensComponent;
  @ViewChild('contentShell') contentShellRef?: ElementRef<HTMLElement>;
  readonly empresaState = inject(EmpresaStateService);

  // ══════════════════════════════════════════════════════════════════════════
  // Pedido de Venda: esconde a barra de rolagem nativa do content-shell e
  // mostra setas flutuantes (▲ topo / ▼ rodapé) indicando que há mais
  // conteúdo pra rolar — só nessa tela (pedido do usuário). O MutationObserver
  // recalcula as setas sempre que o conteúdo muda de altura (itens
  // adicionados/removidos), sem precisar instrumentar cada ponto do código
  // que altera a tela.
  // ══════════════════════════════════════════════════════════════════════════
  mostrarSetaScrollCima  = signal(false);
  mostrarSetaScrollBaixo = signal(false);
  private _scrollShellObserver?: MutationObserver;
  // effect() declarado como campo logo abaixo de "activeView" (ver mais
  // abaixo nesta classe) — precisa que o signal já exista quando o effect
  // roda pela primeira vez durante a construção do componente.

  /** Listener nativo de scroll (fora da Angular zone, ver
   *  _iniciarObservacaoScrollPedidoVenda) — guardado como campo pra dar pra
   *  remover certinho em removeEventListener depois. */
  private _onScrollNativoPedidoVenda = (ev: Event) => this._atualizarSetasScroll(ev.target as HTMLElement);

  private _iniciarObservacaoScrollPedidoVenda(): void {
    const el = this.contentShellRef?.nativeElement;
    if (!el) return;
    this._atualizarSetasScroll(el);
    if (this._scrollShellObserver) return; // já observando
    this._scrollShellObserver = new MutationObserver(() => {
      // Só recalcula enquanto a tela de Pedido de Venda estiver ativa
      if (this.activeView() === 'pedido-venda') this._atualizarSetasScroll(el);
    });
    this._scrollShellObserver.observe(el, { childList: true, subtree: true });

    // IMPORTANTE: listener de scroll nativo (addEventListener), não o
    // binding (scroll)="..." do template — esse último roda DENTRO da zone
    // do Angular, disparando um ciclo de change detection completo a CADA
    // evento de scroll (scroll dispara dezenas de vezes por segundo durante
    // rolagem por trackpad/inércia). Isso é o que causava aquele leve
    // "tremor" do cabeçalho fixo durante a rolagem — não era a barra de
    // rolagem oculta, era o change detection brigando com o scroll a cada
    // frame. runOutsideAngular resolve: só os 2 signals abaixo (que só
    // mudam quando cruza o topo/fundo) reentram na zone, via .set() do
    // signal (que já agenda a atualização certinha sozinho).
    this.ngZone.runOutsideAngular(() => {
      el.addEventListener('scroll', this._onScrollNativoPedidoVenda, { passive: true });
    });
  }

  private _pararObservacaoScrollPedidoVenda(): void {
    this._scrollShellObserver?.disconnect();
    this._scrollShellObserver = undefined;
    this.contentShellRef?.nativeElement.removeEventListener('scroll', this._onScrollNativoPedidoVenda);
    this.mostrarSetaScrollCima.set(false);
    this.mostrarSetaScrollBaixo.set(false);
  }

  private _atualizarSetasScroll(el: HTMLElement): void {
    const folga = 8; // px de tolerância antes de considerar "no topo/fundo"
    const mostrarCima  = el.scrollTop > folga;
    const mostrarBaixo = el.scrollTop + el.clientHeight < el.scrollHeight - folga;
    const mudouCima  = mostrarCima  !== this.mostrarSetaScrollCima();
    const mudouBaixo = mostrarBaixo !== this.mostrarSetaScrollBaixo();
    if (!mudouCima && !mudouBaixo) return; // maioria dos eventos de scroll: nada muda, nem reentra na zone
    // Só reentra na zone (agendando change detection) nos raros momentos em
    // que a seta realmente precisa aparecer/sumir — não a cada scroll tick.
    this.ngZone.run(() => {
      if (mudouCima)  this.mostrarSetaScrollCima.set(mostrarCima);
      if (mudouBaixo) this.mostrarSetaScrollBaixo.set(mostrarBaixo);
    });
  }

  rolarContentShell(direcao: 'cima' | 'baixo'): void {
    const el = this.contentShellRef?.nativeElement;
    if (!el) return;
    const delta = el.clientHeight * 0.85;
    el.scrollBy({ top: direcao === 'baixo' ? delta : -delta, behavior: 'smooth' });
  }

  /** De onde veio a ação de status silenciosa em andamento (via
   *  acaoStatusImportar/acaoStatusConcluida) — define o que fazer quando
   *  ela concluir (ver onAcaoStatusConcluida). 'pedido-lista' é o fluxo
   *  original (Cancelar/Estornar pela Lista de Pedidos); 'conferencia' é o
   *  Finalizar/Cliente Retira da tela de Conferência de Estoque, que só
   *  sobrescreve o GPL_STATUS para "PRONTO" depois que o addon nativo já
   *  finalizou a conferência. */
  private _origemAcaoStatus: 'pedido-lista' | 'conferencia' = 'pedido-lista';

  // ══════════════════════════════════════════════════════════════════════════
  // Consulta Global de Peças (F7 / Shift+F7 — abre de qualquer tela)
  // ══════════════════════════════════════════════════════════════════════════
  consultaPecasAberta             = false;
  consultaPecasTermo              = '';
  consultaPecasResultados: any[]  = [];
  consultaPecasCarregando         = false;
  consultaPecasSemResultado       = false;
  // Produto selecionado para o painel de Estoque por Local (pode ser o principal OU um alternativo).
  consultaPecasProdutoSelecionado: any = null;
  // Produto principal cuja sub-lista de alternativos está expandida — fica fixo nele mesmo
  // ao clicar num alternativo, senão o *ngIf da sub-lista (antes ligado a
  // consultaPecasProdutoSelecionado) recolhe a lista assim que um alternativo é selecionado.
  consultaPecasProdutoExpandido: any = null;
  consultaPecasLocais: any[]      = [];
  consultaPecasLocaisCarregando   = false;
  consultaPecasAlternativos: any[]        = [];
  consultaPecasAlternativosCarregando     = false;
  /** Cotação do dólar mais recente (TSICOT, CODMOEDA=4) — usada para calcular a coluna "Valor R$". */
  consultaPecasCotacaoAtual       = 0;
  private _consultaPecasSubject   = new Subject<string>();

  // Imagem do produto selecionado (painel lateral direito) + preview ampliado
  // — mesmo padrão do Pedido de Venda (F3) e Pedido de Compra (F7), reaproveitando
  // o mesmo endpoint ProdutoGlobalSP.doBuscarImg já usado na Edição de Produtos.
  consultaPecasImagemUrl: string | null = null;
  consultaPecasImagemCarregando = false;
  private _consultaPecasImagemToken = 0;
  // Todas as imagens do produto (principal do TGFPRO + histórico do GPL_PRODUTOSIMG),
  // usadas para montar a faixa de miniaturas e navegar no preview ampliado.
  consultaPecasImagensExtras: string[] = [];
  consultaPecasImagemIndexAtivo = 0;
  consultaImagemPreviewAberta = false;

  private _carregarImagemProdutoConsulta(codprod: number): void {
    this.consultaPecasImagemUrl = null;
    this.consultaPecasImagensExtras = [];
    this.consultaPecasImagemIndexAtivo = 0;
    if (!codprod) { this.consultaPecasImagemCarregando = false; return; }
    this.consultaPecasImagemCarregando = true;
    const token = ++this._consultaPecasImagemToken;
    this.gw.buscarImgProdutoEdicao({CODPROD: codprod}).subscribe({
      next: (res: any) => {
        if (token !== this._consultaPecasImagemToken) return;
        const body = res?.responseBody ?? res;
        const imagens: string[] = [];
        if (body?.principal) {
          imagens.push(`data:image/jpeg;base64,${body.principal}`);
        }
        for (const img of (body?.lista ?? [])) {
          if (img?.imagem) imagens.push(`data:image/jpeg;base64,${img.imagem}`);
        }
        this.consultaPecasImagensExtras = imagens;
        this.consultaPecasImagemIndexAtivo = 0;
        this.consultaPecasImagemUrl = imagens.length > 0 ? imagens[0] : null;
        this.consultaPecasImagemCarregando = false;
      },
      error: () => {
        if (token !== this._consultaPecasImagemToken) return;
        this.consultaPecasImagemUrl = null;
        this.consultaPecasImagensExtras = [];
        this.consultaPecasImagemIndexAtivo = 0;
        this.consultaPecasImagemCarregando = false;
      }
    });
  }

  abrirPreviewImagemConsulta(): void {
    if (!this.consultaPecasImagemUrl) return;
    this.consultaImagemPreviewAberta = true;
  }

  fecharPreviewImagemConsulta(): void {
    this.consultaImagemPreviewAberta = false;
  }

  /** Troca a imagem em destaque (painel lateral e preview ampliado) pela de índice `index`. */
  selecionarImagemConsulta(index: number): void {
    if (index < 0 || index >= this.consultaPecasImagensExtras.length) return;
    this.consultaPecasImagemIndexAtivo = index;
    this.consultaPecasImagemUrl = this.consultaPecasImagensExtras[index];
  }

  /** Navega pra imagem anterior/próxima dentro do preview ampliado (quando há mais de uma). */
  imagemPreviewNavegarConsulta(passo: 1 | -1, event?: Event): void {
    event?.stopPropagation();
    const total = this.consultaPecasImagensExtras.length;
    if (total < 2) return;
    const novo = (this.consultaPecasImagemIndexAtivo + passo + total) % total;
    this.selecionarImagemConsulta(novo);
  }

  @HostListener('document:keydown', ['$event'])
  onGlobalKeydown(event: KeyboardEvent): void {
    if (event.key === 'F7') {
      const tag = (event.target as HTMLElement)?.tagName?.toLowerCase();
      if (tag === 'textarea') return;
      event.preventDefault();
      // F7 / Shift+F7: alterna — abre se fechada, fecha se aberta
      if (this.consultaPecasAberta) {
        this.fecharConsultaPecas();
      } else {
        this.abrirConsultaPecas();
      }
    }
    if (event.key === 'Escape' && this.consultaImagemPreviewAberta) {
      this.fecharPreviewImagemConsulta();
      return;
    }
    if (event.key === 'ArrowLeft' && this.consultaImagemPreviewAberta) {
      this.imagemPreviewNavegarConsulta(-1);
      return;
    }
    if (event.key === 'ArrowRight' && this.consultaImagemPreviewAberta) {
      this.imagemPreviewNavegarConsulta(1);
      return;
    }
    if (event.key === 'Escape' && this.consultaPecasAberta) {
      this.fecharConsultaPecas();
    }
  }

  abrirConsultaPecas(): void {
    if (this.consultaPecasAberta) return;
    this.consultaPecasTermo              = '';
    this.consultaPecasResultados         = [];
    this.consultaPecasCarregando         = false;
    this.consultaPecasSemResultado       = false;
    this.consultaPecasProdutoSelecionado = null;
    this.consultaPecasProdutoExpandido   = null;
    this.consultaPecasLocais             = [];
    this.consultaPecasLocaisCarregando   = false;
    this.consultaPecasImagemUrl          = null;
    this.consultaPecasImagensExtras      = [];
    this.consultaPecasImagemIndexAtivo    = 0;
    this.consultaImagemPreviewAberta     = false;
    this.consultaPecasAberta             = true;
    this._consultaPecasSubject = new Subject<string>();
    this._consultaPecasSubject.pipe(debounceTime(400), distinctUntilChanged())
      .subscribe(termo => this._executarConsultaPecas(termo));
    setTimeout(() => {
      document.querySelector<HTMLInputElement>('.consulta-pecas-input')?.focus();
    }, 60);
    this._carregarCotacaoConsultaPecas();
  }

  /** Busca a cotação de dólar mais recente para exibir a coluna "Valor R$" na Consulta de Peças. */
  private async _carregarCotacaoConsultaPecas(): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.gw.buscarCotacoesDemonstrativo());
      const body = res?.responseBody ?? res;
      const cotacoes: any[] = body?.cotacoes ?? [];
      if (cotacoes.length > 0) {
        const raw = cotacoes[0]?.valor;
        const valor = parseFloat(String(raw ?? '').replace(',', '.'));
        this.consultaPecasCotacaoAtual = isNaN(valor) ? 0 : valor;
      }
    } catch (err) {
      console.error('[ConsultaPecas] erro ao buscar cotação:', err);
    }
  }

  fecharConsultaPecas(): void {
    this.consultaPecasAberta                    = false;
    this.consultaPecasTermo                     = '';
    this.consultaPecasResultados                = [];
    this.consultaPecasSemResultado              = false;
    this.consultaPecasProdutoSelecionado        = null;
    this.consultaPecasProdutoExpandido          = null;
    this.consultaPecasLocais                    = [];
    this.consultaPecasAlternativos              = [];
    this.consultaPecasAlternativosCarregando    = false;
    this.consultaPecasImagemUrl                 = null;
    this.consultaPecasImagensExtras      = [];
    this.consultaPecasImagemIndexAtivo    = 0;
    this.consultaImagemPreviewAberta            = false;
  }

  onConsultaPecasInput(): void {
    this._consultaPecasSubject.next(this.consultaPecasTermo);
  }

  private async _executarConsultaPecas(termo: string): Promise<void> {
    const t = termo.trim();
    if (t.length < 2) {
      this.consultaPecasResultados         = [];
      this.consultaPecasSemResultado       = false;
      this.consultaPecasProdutoSelecionado = null;
      this.consultaPecasProdutoExpandido   = null;
      this.consultaPecasLocais             = [];
      this.consultaPecasImagemUrl          = null;
      this.consultaPecasImagensExtras      = [];
      this.consultaPecasImagemIndexAtivo    = 0;
      return;
    }
    this.consultaPecasCarregando         = true;
    this.consultaPecasSemResultado       = false;
    this.consultaPecasProdutoSelecionado = null;
    this.consultaPecasProdutoExpandido   = null;
    this.consultaPecasLocais             = [];
    this.consultaPecasImagemUrl          = null;
    this.consultaPecasImagensExtras      = [];
    this.consultaPecasImagemIndexAtivo    = 0;
    this.filtrosConsulta                 = {}; // nova busca zera filtros de coluna anteriores
    try {
      const codEmpNum = Number(this.empresaState.selecionada) || undefined;
      const resPN: any = await firstValueFrom(this.gw.buscarPecasModal({ REFFORN: t, CODEMP: codEmpNum }));
      const listaPN: any[] = (resPN?.responseBody ?? resPN)?.lista ?? [];
      if (listaPN.length > 0) {
        this.consultaPecasResultados   = listaPN;
        this.consultaPecasSemResultado = false;
        if (listaPN.length === 1) this.selecionarProdutoConsulta(listaPN[0]);
        return;
      }
      const resDesc: any = await firstValueFrom(this.gw.buscarPecasModal({ DESCRICAO: t, CODEMP: codEmpNum }));
      const listaDesc: any[] = (resDesc?.responseBody ?? resDesc)?.lista ?? [];
      this.consultaPecasResultados   = listaDesc;
      this.consultaPecasSemResultado = listaDesc.length === 0;
      if (listaDesc.length === 1) this.selecionarProdutoConsulta(listaDesc[0]);
    } catch (err) {
      console.error('[ConsultaPecas] erro:', err);
      this.consultaPecasSemResultado = true;
    } finally {
      this.consultaPecasCarregando = false;
    }
  }

  async selecionarProdutoConsulta(prod: any): Promise<void> {
    this.consultaPecasProdutoSelecionado        = prod;
    // Fixa o produto principal expandido — usado pelo *ngIf da sub-lista de
    // alternativos, que precisa continuar visível ao clicar num alternativo.
    this.consultaPecasProdutoExpandido          = prod;
    this.consultaPecasLocais                    = [];
    this.consultaPecasLocaisCarregando          = true;
    this.consultaPecasAlternativos              = [];
    this.consultaPecasAlternativosCarregando    = true;

    const codprod = Number(prod.codprod);
    this._carregarImagemProdutoConsulta(codprod);

    if (!codprod) {
      this.consultaPecasLocaisCarregando       = false;
      this.consultaPecasAlternativosCarregando = false;
      return;
    }

    // Estoque por local (aguardado)
    try {
      const res: any = await firstValueFrom(this.gw.buscarEstoquePorLocal(codprod));
      const lista: any[] = (res?.responseBody ?? res)?.locais ?? [];
      this.consultaPecasLocais = this._agruparLocais(lista.map((l: any) => ({
        codemp:       Number(l.codemp),
        nomeEmp:      l.nomeEmp      ?? l.nomeemp      ?? '',
        descrLocal:   l.descrLocal   ?? l.descrlocal   ?? l.DESCRLOCAL ?? '',
        qtdTotal:     Number(l.qtdTotal    ?? l.qtdtotal    ?? l.QTDTOTAL    ?? 0),
        qtdReservada: Number(l.qtdReservada ?? l.qtdreservada ?? l.QTDRESERVADA ?? 0),
        disponivel:   Number(l.disponivel  ?? l.DISPONIVEL  ?? 0),
      })));
    } catch (err) {
      console.error('[ConsultaPecas] erro estoque:', err);
    } finally {
      this.consultaPecasLocaisCarregando = false;
    }

    // Alternativos TGFPAL (fire-and-forget)
    const codEmpAlt = Number(this.empresaState.selecionada) || undefined;
    this.gw.buscarAlternativosProduto(codprod, codEmpAlt).subscribe({
      next: (res: any) => {
        const body = res?.responseBody ?? res;
        this.consultaPecasAlternativos           = body?.lista ?? [];
        this.consultaPecasAlternativosCarregando = false;
      },
      error: () => { this.consultaPecasAlternativosCarregando = false; }
    });
  }

  /** Clique em linha de alternativo no F7: carrega estoque SEM recarregar a lista de alternativos. */
  async selecionarAlternativoConsulta(alt: any): Promise<void> {
    this.consultaPecasProdutoSelecionado = alt;
    this.consultaPecasLocais             = [];
    this.consultaPecasLocaisCarregando   = true;
    const codprod = Number(alt.codprod);
    this._carregarImagemProdutoConsulta(codprod);
    if (!codprod) { this.consultaPecasLocaisCarregando = false; return; }
    try {
      const res: any = await firstValueFrom(this.gw.buscarEstoquePorLocal(codprod));
      const lista: any[] = (res?.responseBody ?? res)?.locais ?? [];
      this.consultaPecasLocais = this._agruparLocais(lista.map((l: any) => ({
        codemp:       Number(l.codemp),
        nomeEmp:      l.nomeEmp      ?? l.nomeemp      ?? '',
        descrLocal:   l.descrLocal   ?? l.descrlocal   ?? l.DESCRLOCAL ?? '',
        qtdTotal:     Number(l.qtdTotal    ?? l.qtdtotal    ?? l.QTDTOTAL    ?? 0),
        qtdReservada: Number(l.qtdReservada ?? l.qtdreservada ?? l.QTDRESERVADA ?? 0),
        disponivel:   Number(l.disponivel  ?? l.DISPONIVEL  ?? 0),
      })));
    } catch (err) {
      console.error('[ConsultaPecas] erro estoque alternativo:', err);
    } finally {
      this.consultaPecasLocaisCarregando = false;
    }
  }

  private _agruparLocais(lista: any[]): any[] {
    // TODO: agrupamento comentado temporariamente a pedido do usuário, para
    // inspecionar as linhas de estoque por local SEM somar por empresa/local.
    // Reativar removendo o "return lista;" abaixo.
    return lista;

    /*
    const map = new Map<string, any>();
    for (const l of lista) {
      const key = `${l.codemp ?? 0}__${(l.descrLocal ?? '').trim()}`;
      if (map.has(key)) {
        const e = map.get(key)!;
        e.qtdTotal     = (e.qtdTotal     ?? 0) + (l.qtdTotal     ?? 0);
        e.qtdReservada = (e.qtdReservada ?? 0) + (l.qtdReservada ?? 0);
        e.disponivel   = (e.disponivel   ?? 0) + (l.disponivel   ?? 0);
      } else {
        map.set(key, { ...l });
      }
    }
    return Array.from(map.values());
    */
  }

  consultaTotalLocais(campo: 'qtdTotal' | 'qtdReservada' | 'disponivel'): number {
    return this.consultaPecasLocais.reduce((acc, l) => acc + ((l[campo] as number) ?? 0), 0);
  }

  /** Formata quantidades para remover os decimais vazios (.000) caso seja um número inteiro,
   *  sem usar o pipe nativo que pode se confundir com separadores. */
  fmtQtd(valor: any, unidade?: string | null): string {
    if (valor == null || valor === '') return '0';
    // Remove vírgulas/pontos extras e transforma em número nativo
    let numStr = String(valor).replace(/,/g, '.');
    // Se a string vier como "20.000", parsefloat pega 20
    let num = parseFloat(numStr);
    if (isNaN(num)) return String(valor);

    // Se não tiver fração (ex: 20), formata como inteiro, independente da unidade.
    // Isso evita mostrar 20.000.
    if (Number.isFinite(num) && Math.abs(num - Math.round(num)) < 1e-6) {
      return num.toLocaleString('pt-BR', { maximumFractionDigits: 0 });
    }
    
    // Se tiver fração, exibe até 3 ou 4 casas
    return num.toLocaleString('pt-BR', { maximumFractionDigits: 4 });
  }

  fmtQtdEstoqueLocal(valor?: number | null): string {
    return this.fmtQtd(valor, this.consultaPecasProdutoSelecionado?.codvol);
  }

  /**
   * Converte Valor Moeda → Valor R$ na tela de Consulta de Peças (F7), principal
   * e alternativos. Fabricante NACIONAL (origemNacional) não converte pela
   * cotação — Valor R$ recebe o mesmo valor do Valor Moeda.
   */
  valorEmReaisConsulta(vlrVenda: number | null | undefined, origemNacional: boolean | null | undefined, cotacao: number): number | null {
    if (vlrVenda == null) return null;
    if (origemNacional) return vlrVenda;
    return cotacao > 0 ? vlrVenda * cotacao : null;
  }

  /** Valor unitário do IPI (R$) do produto na Consulta de Peças — preço R$ × alíquota IPI
   *  (a alíquota já vem no resultado da busca, via JOIN com TGFIPI no backend). */
  vlrIpiUnitarioConsulta(p: any, cotacao: number): number {
    const precoBrl = this.valorEmReaisConsulta(p?.vlrVenda, p?.origemNacional, cotacao);
    const aliq = parseFloat(String(p?.aliqIpi ?? p?.aliq_ipi ?? '0').replace(',', '.')) || 0;
    return precoBrl != null && aliq > 0 ? parseFloat((precoBrl * aliq / 100).toFixed(2)) : 0;
  }

  /** Valor Moeda (U$) já somado o IPI unitário (IPI é sempre em R$, convertido pela cotação). */
  valorMoedaComIpiConsulta(p: any, cotacao: number): number | null {
    if (p?.vlrVenda == null) return null;
    const ipiUsd = cotacao > 0 ? this.vlrIpiUnitarioConsulta(p, cotacao) / cotacao : 0;
    return parseFloat((p.vlrVenda + ipiUsd).toFixed(2));
  }

  /** Valor R$ já somado o IPI unitário. */
  valorReaisComIpiConsulta(p: any, cotacao: number): number | null {
    const precoBrl = this.valorEmReaisConsulta(p?.vlrVenda, p?.origemNacional, cotacao);
    if (precoBrl == null) return null;
    return parseFloat((precoBrl + this.vlrIpiUnitarioConsulta(p, cotacao)).toFixed(2));
  }

  // ── Ordenação da tabela de resultados (Consulta de Peças / F7) ───────────
  consultaPecasOrdenarCampo: string | null = null;
  consultaPecasOrdemAsc = true;

  // ── Filtro por coluna (em tela, sobre os resultados já carregados) ───────
  filtrosConsulta: { [campo: string]: string } = {};

  /** Resultados exibidos na tabela: consultaPecasResultados após aplicar os
   *  filtros de coluna ativos em filtrosConsulta. Não muta consultaPecasResultados
   *  (a ordenação continua funcionando normalmente sobre a lista completa). */
  get consultaPecasResultadosExibidos(): any[] {
    const campos = Object.keys(this.filtrosConsulta).filter(c => (this.filtrosConsulta[c] || '').trim().length > 0);
    if (campos.length === 0) return this.consultaPecasResultados;
    return this.consultaPecasResultados.filter(p => campos.every(campo => {
      const termo = this.filtrosConsulta[campo].trim().toLowerCase();
      const valor = this._valorOrdenacaoConsulta(p, campo);
      return String(valor ?? '').toLowerCase().includes(termo);
    }));
  }

  limparFiltroConsulta(campo: string, event?: Event): void {
    event?.stopPropagation();
    delete this.filtrosConsulta[campo];
  }

  temFiltroConsulta(campo: string): boolean {
    return !!(this.filtrosConsulta[campo] || '').trim();
  }

  /** Coluna cujo campo de filtro está aberto para digitação (inline no
   *  próprio cabeçalho, ao clicar no nome da coluna) — só uma por vez. */
  colunaFiltroConsultaAberta: string | null = null;

  toggleFiltroConsulta(campo: string, event?: Event): void {
    event?.stopPropagation();
    this.colunaFiltroConsultaAberta = this.colunaFiltroConsultaAberta === campo ? null : campo;
    if (this.colunaFiltroConsultaAberta === campo) {
      setTimeout(() => document.getElementById('filtro-consulta-' + campo)?.focus(), 0);
    }
  }

  /** Fecha o campo de digitação ao perder o foco/Enter — o filtro
   *  continua aplicado normalmente, só o input inline é que recolhe. */
  fecharFiltroConsulta(): void {
    this.colunaFiltroConsultaAberta = null;
  }

  ordenarConsultaPecas(campo: string): void {
    if (this.consultaPecasOrdenarCampo === campo) {
      this.consultaPecasOrdemAsc = !this.consultaPecasOrdemAsc;
    } else {
      this.consultaPecasOrdenarCampo = campo;
      this.consultaPecasOrdemAsc = true;
    }
    const dir = this.consultaPecasOrdemAsc ? 1 : -1;
    this.consultaPecasResultados = [...this.consultaPecasResultados].sort((a, b) => {
      const va = this._valorOrdenacaoConsulta(a, campo);
      const vb = this._valorOrdenacaoConsulta(b, campo);
      if (va == null && vb == null) return 0;
      if (va == null) return 1;  // sem valor sempre por último, nas duas direções
      if (vb == null) return -1;
      if (typeof va === 'string' && typeof vb === 'string') return va.localeCompare(vb, 'pt-BR') * dir;
      return ((va as number) - (vb as number)) * dir;
    });
  }

  private _valorOrdenacaoConsulta(p: any, campo: string): string | number | null {
    switch (campo) {
      case 'pn':            return String(p.refforn ?? p.referencia ?? p.codprod ?? '');
      case 'cd':             return String(p.condicao ?? '');
      case 'descricao':      return String(p.descricao ?? '');
      case 'alternativo':    return String(p.alternativo ?? '');
      case 'un':             return String(p.codvol ?? '');
      case 'estoque':        return p.estoque ?? 0;
      case 'valorMoeda':     return p.vlrVenda ?? null;
      case 'valorReais':     return this.valorEmReaisConsulta(p.vlrVenda, p.origemNacional, this.consultaPecasCotacaoAtual);
      case 'valorMoedaIpi':  return this.valorMoedaComIpiConsulta(p, this.consultaPecasCotacaoAtual);
      case 'valorReaisIpi':  return this.valorReaisComIpiConsulta(p, this.consultaPecasCotacaoAtual);
      case 'vlrIpi':         return this.vlrIpiUnitarioConsulta(p, this.consultaPecasCotacaoAtual);
      case 'fabricante':     return String(p.marca ?? '');
      case 'origem':         return String(p.origem ?? '');
      case 'dataUltAtual':   return this._dataBrParaOrdenacaoConsulta(p.dataUltAtualPreco);
      case 'limiteDias':     return p.limitePrazoAtualDias > 0 ? p.limitePrazoAtualDias : null;
      case 'codigo':         return p.codprod ?? null;
      default:               return null;
    }
  }

  /** Converte "dd/MM/yyyy" num número comparável (yyyyMMdd) pra ordenar por data
   *  sem depender de new Date(str), que é ambíguo entre browsers/locales. */
  private _dataBrParaOrdenacaoConsulta(dataBr: string | null | undefined): number | null {
    if (!dataBr) return null;
    const partes = dataBr.split('/');
    if (partes.length !== 3) return null;
    const dd = parseInt(partes[0], 10), mm = parseInt(partes[1], 10), yyyy = parseInt(partes[2], 10);
    if (!dd || !mm || !yyyy) return null;
    return yyyy * 10000 + mm * 100 + dd;
  }

  corLinhaConsulta(codemp: number): string {
    const key = String(codemp ?? '');
    const hex = this.empresaState.CORES[key];
    if (!hex) return '';
    const c = hex.replace('#', '');
    const r = parseInt(c.substring(0, 2), 16);
    const g = parseInt(c.substring(2, 4), 16);
    const b = parseInt(c.substring(4, 6), 16);
    const f = 0.75;
    const rr = Math.round(r + (255 - r) * f).toString(16).padStart(2, '0');
    const gg = Math.round(g + (255 - g) * f).toString(16).padStart(2, '0');
    const bb = Math.round(b + (255 - b) * f).toString(16).padStart(2, '0');
    return `#${rr}${gg}${bb}`;
  }

  // ── View / Sidebar ────────────────────────────────────────────────────────
  // Celular (≤ 900px): o menu lateral começa recolhido; a navegação fica na barra inferior.
  sidebarCollapsed = signal(typeof window !== 'undefined' && window.innerWidth <= 900);
  activeView       = signal<GatewayView>('home');

  // CODPROD a abrir automaticamente ao entrar na tela de Edição de Produtos
  // (vindo do card "Produto Cadastrado com Sucesso!" da tela de Cadastrar
  // Produto -- ver onIrParaEdicaoProduto()).
  produtoEdicaoAutoAbrir = signal<string | null>(null);

  /** Tela de onde a Edicao foi aberta: ao salvar/descartar volta pra ela (Lista de Produtos). Null = fica na propria Edicao. */
  produtoEdicaoOrigem = signal<'lista-produtos' | null>(null);

  onIrParaEdicaoProduto(codProd: string, origem: 'lista-produtos' | null = null): void {
    this.produtoEdicaoOrigem.set(origem);
    this.produtoEdicaoAutoAbrir.set(codProd);
    this.navigate('gpl-edicaodeprodutos');
  }

  /** Salvou ou descartou a edicao de um item aberto pela Lista de Produtos: volta pra Lista. */
  onVoltarDaEdicaoProduto(): void {
    this.produtoEdicaoOrigem.set(null);
    this.navigate('lista-produtos');
  }

  /** Chamado pelo <app-gpl-edicao-produtos> assim que ele consome o
   * codProdAutoAbrir. Adiado pro próximo tick (setTimeout) pra não mexer no
   * signal durante o ngOnChanges do próprio filho (evita
   * ExpressionChangedAfterItHasBeenCheckedError em dev). */
  onProdutoEdicaoAutoAbrirConsumido(): void {
    setTimeout(() => this.produtoEdicaoAutoAbrir.set(null));
  }

  produtoCadastroAutoPreencherPN = signal<string | null>(null);

  /** Produto a clonar: vem do botão "Clonar" da tela de Edição e abre o Cadastrar já com ele como modelo. */
  produtoCadastroClonar = signal<{ codprod: string; partNumber: string; nome: string; imagem?: string } | null>(null);

  /** Tela de onde o Clonar foi disparado (Cancelar/Voltar no Cadastro retorna pra ela). */
  produtoCadastroClonarOrigem = signal<'lista-produtos' | 'gpl-edicaodeprodutos' | null>(null);

  onClonarProduto(p: { codprod: string; partNumber: string; nome: string; imagem?: string },
                  origem: 'lista-produtos' | 'gpl-edicaodeprodutos' | null = null): void {
    this.produtoCadastroAutoPreencherPN.set(null);
    this.produtoCadastroClonarOrigem.set(origem);
    this.produtoCadastroClonar.set(p);
    this.navigate('duplicar-produto');
  }

  onProdutoCadastroClonarConsumido(): void {
    setTimeout(() => this.produtoCadastroClonar.set(null));
  }

  /** Cancelar/Voltar do Cadastro iniciado por um Clonar: volta pra tela de origem. */
  onVoltarDoCadastroClonado(e: { origem: 'lista-produtos' | 'gpl-edicaodeprodutos'; codprod: string }): void {
    this.produtoCadastroClonarOrigem.set(null);
    if (e.origem === 'gpl-edicaodeprodutos') {
      this.produtoEdicaoAutoAbrir.set(e.codprod);
    }
    this.navigate(e.origem);
  }
  
  onProdutoCadastroAutoPreencherConsumido(): void {
    setTimeout(() => this.produtoCadastroAutoPreencherPN.set(null));
  }

  /** Botão "Cadastrar" no header da tela de Edição de Produtos -- volta pra
   * tela de Cadastrar Produto. Como ela é recriada do zero (*ngIf), abre
   * naturalmente na etapa de seleção de modelo. */
  /** Cadastrar aberto pelo botao da Lista de Produtos: ao salvar, volta pra Lista. */
  produtoCadastroOrigemLista = signal(false);

  onIrParaCadastroProduto(pn?: string | void, origemLista = false): void {
    this.produtoCadastroOrigemLista.set(origemLista);
    if (typeof pn === 'string' && pn.trim() !== '') {
      this.produtoCadastroAutoPreencherPN.set(pn.trim());
    } else {
      this.produtoCadastroAutoPreencherPN.set(null);
    }
    this.navigate('duplicar-produto');
  }

  /** Botão "Novo Produto" na tela Lista de Produtos -- mesmo destino do botão
   * "Cadastrar" do menu lateral, só reaproveita o handler acima. */
  onNovoProdutoDaLista(pn?: string | void): void {
    this.onIrParaCadastroProduto(pn, true);
  }

  // Controle de sidebar ao entrar/sair do Pedido de Venda — colapsa o menu
  // lateral pra dar mais espaço à tela inteira (todas as abas: Dados,
  // Endereços, Itens, etc.), não só a aba Itens como era antes. Restaura o
  // estado anterior automaticamente ao sair da tela, seja qual for o
  // caminho de saída (Voltar, salvar, navegar pelo menu).
  private _sidebarAntesPedidoVenda: boolean | null = null;
  private readonly _sidebarPedidoVendaEffect = effect(() => {
    const view = this.activeView();
    const compraItens = this.pedidoCompraAbaItens();
    const preCompraItens = this.preCompraAbaItens();
    const compraItens2 = this.compraAbaItens();
    untracked(() => {
      if (view === 'pedido-venda' || view === 'pre-venda' || (view === 'pedido-compra-form' && compraItens)
          || (view === 'pre-compra-form' && preCompraItens) || (view === 'compra-form' && compraItens2)) {
        if (this._sidebarAntesPedidoVenda === null) {
          this._sidebarAntesPedidoVenda = this.sidebarCollapsed();
        }
        this.sidebarCollapsed.set(true);
      } else if (this._sidebarAntesPedidoVenda !== null) {
        this.sidebarCollapsed.set(this._sidebarAntesPedidoVenda);
        this._sidebarAntesPedidoVenda = null;
      }
    });
  });
  // Precisa vir DEPOIS de "activeView" acima — o effect() executa uma vez
  // imediatamente na construção do componente e lê this.activeView().
  // DESLIGADO a pedido do usuário (setas ocultadas em *ngIf="false" no
  // gateway.component.html) — mantido comentado, não removido, porque o
  // MutationObserver{childList,subtree} + o ngZone.run() do
  // _atualizarSetasScroll são a suspeita mais forte de um travamento de
  // tela grave (RESULT_CODE_HUNG no Chrome) relatado ao clicar em botões
  // de "Copiar dados" no Pedido de Venda: qualquer mutação no DOM dentro
  // de .content-shell (como abrir/fechar um menu) dispara o observer, que
  // pode reentrar na zone e potencialmente causar mais mutações,
  // formando um ciclo. Como as setas já estavam ocultas (sem uso visual
  // no momento), não há motivo pra manter esse observer rodando.
  // private readonly _pedidoVendaScrollEffect = effect(() => {
  //   const view = this.activeView();
  //   if (view === 'pedido-venda') {
  //     setTimeout(() => this._iniciarObservacaoScrollPedidoVenda(), 50);
  //   } else {
  //     this._pararObservacaoScrollPedidoVenda();
  //   }
  // });
  pedidoEditando          = signal<number | null>(null);
  pedidoCompraEditando    = signal<number | null>(null);
  itensImportarDeOS       = signal<{ pn: string; quantidade: number; vlrDescAcresc?: number }[] | null>(null);
  observacaoImportarDeOS  = signal<string | null>(null);
  origemOSImportar = signal<{
    numOs?: string | number;
    empresaNome?: string;
    clienteNome?: string;
    aeronaveMatricula?: string;
  } | null>(null);
  /** Cancelar (leve) / Estornar disparados pela Lista — grava em segundo
   *  plano na tela de Pedido de Venda (nunca fica visível). */
  acaoStatusImportar = signal<{
    nunota: number;
    novoGplStatus: string;
    novoCodTipOper?: number;
  } | null>(null);
  separacaoNunota         = signal<number | null>(null);
  /** Id da venda no Aerosys + número exibido, para a tela "Continuar Separação" do
   *  Sistema Legado (estoque-separacao-itens-legado) — par isolado de separacaoNunota,
   *  para não misturar as duas fontes de dados. */
  separacaoLegadoIdVenda  = signal<number | null>(null);
  separacaoLegadoNumVenda = signal<string | undefined>(undefined);
  conferenciaNunota      = signal<number | null>(null);
  /** Id da venda no Aerosys + número exibido, para a tela "Continuar Conferência" do
   *  Sistema Legado (estoque-conferencia-itens-legado) — par isolado de conferenciaNunota,
   *  mesmo motivo de separacaoLegadoIdVenda acima. */
  conferenciaLegadoIdVenda  = signal<number | null>(null);
  conferenciaLegadoNumVenda = signal<string | undefined>(undefined);
  logisticaNunota        = signal<number | null>(null);
  pendenciaVendedorNunota = signal<number | null>(null);

  navigate(view: GatewayView): void {
    // Saindo da tela de Pedido de Venda (Nova Venda ou edição) pelo menu —
    // mesma confirmação que já existe no botão Voltar, pra não perder
    // alterações não salvas ao clicar em outro item do menu.
    if (this.activeView() === 'pedido-venda' && view !== 'pedido-venda' && this.pedidoVendaRef) {
      const podeNavegarJa = this.pedidoVendaRef.solicitarSaida(() => this._realizarNavegacao(view));
      if (!podeNavegarJa) return; // aguardando confirmação do modal
    }
    if (this.activeView() === 'pre-venda' && view !== 'pre-venda' && this.preVendaRef) {
      const podeNavegarJa = this.preVendaRef.solicitarSaida(() => this._realizarNavegacao(view));
      if (!podeNavegarJa) return;
    }
    // Idem para o Pedido de Compra (novo ou edição).
    if (this.activeView() === 'pedido-compra-form' && view !== 'pedido-compra-form' && this.pedidoCompraFormRef) {
      const podeNavegarJa = this.pedidoCompraFormRef.solicitarSaida(() => this._realizarNavegacao(view));
      if (!podeNavegarJa) return;
    }
    // Idem para Pré-Compra e Compra.
    if (this.activeView() === 'pre-compra-form' && view !== 'pre-compra-form' && this.preCompraFormRef) {
      const podeNavegarJa = this.preCompraFormRef.solicitarSaida(() => this._realizarNavegacao(view));
      if (!podeNavegarJa) return;
    }
    if (this.activeView() === 'compra-form' && view !== 'compra-form' && this.compraFormRef) {
      const podeNavegarJa = this.compraFormRef.solicitarSaida(() => this._realizarNavegacao(view));
      if (!podeNavegarJa) return;
    }
    this._realizarNavegacao(view);
  }

  // Cadastro de Parceiros: a view 'cadastro-parceiro' mostra primeiro a lista
  // (ultimos 10); "Cadastrar" abre o formulario e, ao salvar, volta para a lista.
  // Cadastro de Aeronave: mostra primeiro a lista; "Cadastrar" abre o formulario novo e duplo clique abre em edicao.
  aeronaveCadastroAberto = signal(false);
  aeronaveEdicaoPrefixo = signal<string | null>(null);

  parceiroCadastroAberto = signal(false);
  parceiroEdicaoDoc = signal<string | null>(null);
  parceiroEdicaoCod = signal<string | null>(null);
  // Cliente do Aerosys ainda nao cadastrado no Sankhya (Lista de Parceiros > Funcoes > Validar clientes do Aerosys)
  parceiroNovoDoc = signal<string | null>(null);
  parceiroNovoNome = signal<string | null>(null);

  private _realizarNavegacao(view: GatewayView): void {
    this.parceiroCadastroAberto.set(false);
    this.aeronaveCadastroAberto.set(false);
    this.aeronaveEdicaoPrefixo.set(null);
    if (view !== 'gpl-edicaodeprodutos') this.produtoEdicaoOrigem.set(null);
    if (view !== 'duplicar-produto') this.produtoCadastroOrigemLista.set(false);
    const anterior = this.activeView();
    if (view === 'pre-venda' || view === 'pre-venda-lista') this.modoPreVenda.set(true);
    else if (view === 'pedido-venda' || view === 'pedido-venda-lista') this.modoPreVenda.set(false);
    this.activeView.set(view);
    if (window.innerWidth < 1024) {
      this.sidebarCollapsed.set(true);
    }
    // Recarrega a lista silenciosamente sempre que o usuário navega para ela
    // (exceto quando já estava nela — evita duplo carregamento ao abrir o app)
    if (view === 'pedido-venda-lista' && anterior !== 'pedido-venda-lista') {
      setTimeout(() => this.listaAtiva?.buscar(false), 0);
    }
  }

  onNovoPedido(): void {
    this.itensImportarDeOS.set(null);
    this.observacaoImportarDeOS.set(null);
    this.origemOSImportar.set(null);
    this.acaoStatusImportar.set(null);
    this.pedidoEditando.set(null);
    this.activeView.set(this._vForm());
  }

  onEditarPedido(nunota: number): void {
    this.itensImportarDeOS.set(null);
    this.observacaoImportarDeOS.set(null);
    this.origemOSImportar.set(null);
    this.acaoStatusImportar.set(null);
    this.pedidoEditando.set(nunota);
    this.activeView.set(this._vForm());
  }

  /** Pedido de Venda gerado automaticamente a partir de uma O.S — volta para
   *  a Lista de Pedidos já com o pedido recém-gravado selecionado/destacado
   *  (mesmo padrão usado em Desmembrar/Transferir Venda). */
  onOsVendaGravada(nunota: number): void {
    this.pedidoEditando.set(null);
    this.itensImportarDeOS.set(null);
    this.observacaoImportarDeOS.set(null);
    this.origemOSImportar.set(null);
    this.acaoStatusImportar.set(null);
    this.activeView.set(this._vLista());
    setTimeout(() => this.listaAtiva?.focarPedido(nunota), 400);
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Cancelar (leve) / Estornar — só mexem no GPL_STATUS (e, no estorno de um
  // Autorizado, também tentam voltar a TOP para Orçamento). Diferente do
  // Excluir, não usam o cancelamento nativo do Sankhya.
  // ══════════════════════════════════════════════════════════════════════════
  onSolicitarAlterarStatus(payload: { nunota: number; novoGplStatus: string; novoCodTipOper?: number }): void {
    if (this.modoPreVenda()) {
      // Pré-Venda: Cancelar/Estornar direto no gateway (sem tela de edição escondida).
      const acao = payload.novoGplStatus === 'CANCELADO' ? 'CANCELAR' : 'ESTORNAR';
      this.gw.alterarStatusPreVenda(payload.nunota, acao).subscribe({
        next: (r: any) => {
          if (r?.sucesso === false) this.mostrarToast(`Erro ao ${acao === 'CANCELAR' ? 'cancelar' : 'estornar'} a Pré-Venda #${payload.nunota}: ${r?.erro ?? ''}`, 9000);
          else this.mostrarToast(`Status da Pré-Venda #${payload.nunota} atualizado (${r?.statusNovo ?? ''}).`, 5000);
          setTimeout(() => this.listaAtiva?.focarPedido(payload.nunota), 400);
        },
        error: (err: any) => this.mostrarToast(`Erro na Pré-Venda #${payload.nunota}: ${err?.error?.erro ?? err?.message ?? 'erro de comunicação'}`, 9000)
      });
      return;
    }
    this._origemAcaoStatus = 'pedido-lista';
    this.itensImportarDeOS.set(null);
    this.observacaoImportarDeOS.set(null);
    this.origemOSImportar.set(null);
    this.pedidoEditando.set(payload.nunota);
    this.acaoStatusImportar.set(payload);
    // Não troca activeView: a Lista de Pedidos continua visível o tempo
    // todo — o <app-pedido-venda> é montado escondido ([hidden], ver
    // gateway.component.html) só para essa gravação silenciosa, sem o
    // usuário nunca ver a tela de edição abrir.
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Conferência de Estoque — Finalizar / Cliente Retira. O addon nativo
  // (doFinalizarConferencia / doFinalizarConferenciaClienteRetira) já roda
  // antes disso (ver estoque-conferencia-itens.component.ts); esse passo só
  // sobrescreve o GPL_STATUS para "PRONTO" logo em seguida, reaproveitando a
  // mesma gravação silenciosa via <app-pedido-venda> usada no Cancelar/
  // Estornar — sem isso, o GPL_STATUS ficava com o que o addon define
  // internamente (ex.: "FINALIZADO"), e o usuário queria "PRONTO".
  // ══════════════════════════════════════════════════════════════════════════
  onSolicitarFinalizarConferenciaComStatus(payload: { nunota: number; novoGplStatus: string }): void {
    this._origemAcaoStatus = 'conferencia';
    this.itensImportarDeOS.set(null);
    this.observacaoImportarDeOS.set(null);
    this.origemOSImportar.set(null);
    this.pedidoEditando.set(payload.nunota);
    this.acaoStatusImportar.set(payload);
  }

  onAcaoStatusConcluida(res: { nunota: number; sucesso: boolean; mensagem?: string }): void {
    this.pedidoEditando.set(null);
    this.acaoStatusImportar.set(null);

    if (this._origemAcaoStatus === 'conferencia') {
      this._origemAcaoStatus = 'pedido-lista';
      this.conferenciaItensRef?.resolverStatusFinal(res.sucesso, res.mensagem);
      return;
    }

    // activeView já está em 'pedido-venda-lista' (nunca saiu de lá).
    if (res.sucesso) {
      this.mostrarToast(`Status do pedido #${res.nunota} atualizado com sucesso.`, 5000);
      setTimeout(() => this.listaAtiva?.focarPedido(res.nunota), 400);
    } else {
      this.mostrarToast(`Erro ao atualizar status do pedido #${res.nunota}: ${res.mensagem ?? ''}`, 8000);
      setTimeout(() => this.listaAtiva?.buscar(), 400);
    }
  }

  onNovoPedidoCompra(): void {
    this.pedidoCompraEditando.set(null);
    this.activeView.set('pedido-compra-form');
  }

  onEditarPedidoCompra(nunota: number): void {
    this.pedidoCompraEditando.set(nunota);
    this.activeView.set('pedido-compra-form');
  }

  onVoltarListaCompra(): void {
    this.pedidoCompraEditando.set(null);
    this.activeView.set('pedido-compra');
  }

  // ── Pré-Compra (TOP 1301) ────────────────────────────────────────────────
  // Mesmo padrão lista/form do Pedido de Compra (ver onNovoPedidoCompra/
  // onEditarPedidoCompra/onVoltarListaCompra acima).
  preCompraEditando = signal<number | null>(null);

  /** Nova Pré-Compra: antes de abrir o form pergunta o TIPO (NACIONAL = empresa 1 / IMPORTAÇÃO = empresa 12). */
  tipoPreCompraModalAberto = signal(false);
  preCompraTipoNovo = signal<'NACIONAL' | 'IMPORTACAO' | null>(null);

  onNovaPreCompra(): void {
    this.tipoPreCompraModalAberto.set(true);
  }

  escolherTipoNovaPreCompra(tipo: 'NACIONAL' | 'IMPORTACAO'): void {
    this.tipoPreCompraModalAberto.set(false);
    this.preCompraTipoNovo.set(tipo);
    this.preCompraEditando.set(null);
    this.activeView.set('pre-compra-form');
  }

  onEditarPreCompra(nunota: number): void {
    this.preCompraTipoNovo.set(null);
    this.preCompraEditando.set(nunota);
    this.activeView.set('pre-compra-form');
  }

  onVoltarPreCompra(): void {
    this.preCompraEditando.set(null);
    this.activeView.set('pre-compra-lista');
  }

  // ── Compra (TOP 1301 -- temporária, compartilhada com Pré-Compra) ────────
  // Mesmo padrão lista/form.
  compraEditando = signal<number | null>(null);

  onNovaCompra(): void {
    this.compraEditando.set(null);
    this.activeView.set('compra-form');
  }

  onEditarCompra(nunota: number): void {
    this.compraEditando.set(nunota);
    this.activeView.set('compra-form');
  }

  onVoltarCompra(): void {
    this.compraEditando.set(null);
    this.activeView.set('compra-lista');
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Modal: Gerar Pedido de Compra a partir de um Pedido de Venda
  // Gera automaticamente (empresa 1, fornecedor 1, comprador 24) — o modal
  // só serve para escolher quais itens (e em qual quantidade) entram na compra.
  // ══════════════════════════════════════════════════════════════════════════
  modalGerarCompraAberto      = false;
  gerarCompraNunotaOrigem: number | null = null;
  gerarCompraStep: 1 | 2 = 1;
  gerarCompraEmpresaSel = '';   // empresa (codEmp do menu, real ou virtual) em que o pedido será gerado
  get gerarCompraEmpresasOpcoes(): EmpresaOpcao[] { return this.empresaState.opcoes.filter(e => e.codEmp !== '100'); }
  private gerarCompraCodVendOrigem = 0;   // vendedor da venda/pré-venda de origem = comprador do pedido gerado
  gerarCompraCarregando       = false;
  gerarCompraSalvando         = false;
  gerarCompraErro             = '';
  gerarCompraItens: {
    seq: number; codprod: number; refforn: string; descricao: string;
    condicao: string; qtd: number; selecionado: boolean; codvol?: string;
  }[] = [];

  get gerarCompraQtdSelecionados(): number {
    return this.gerarCompraItens.filter(i => i.selecionado).length;
  }

  toggleSelecionarTodosGerarCompra(checked: boolean): void {
    this.gerarCompraItens.forEach(i => i.selecionado = checked);
  }

  onSolicitarGerarPedidoCompra(nunota: number): void {
    this.gerarCompraNunotaOrigem = nunota;
    this.gerarCompraStep         = 1;
    this.gerarCompraEmpresaSel   = String(this.empresaState.selecionada ?? '');
    this.gerarCompraItens        = [];
    this.gerarCompraErro         = '';
    this.gerarCompraSalvando     = false;
    this.gerarCompraCarregando   = true;
    this.modalGerarCompraAberto  = true;

    this.gw.buscarDetalhesPedidoVenda(nunota).subscribe({
      next: (res: any) => {
        const body  = res?.responseBody ?? res;
        const det   = body?.detalhe ?? body;
        this.gerarCompraCodVendOrigem = Number(det?.codvend ?? det?.codVend) || 0;
        const itens: any[] = det?.itens ?? [];
        this.gerarCompraItens = itens
          .filter((it: any) => Number(it.codprod) > 0)
          .map((it: any) => ({
            seq:         Number(it.seq ?? 0),
            codprod:     Number(it.codprod),
            refforn:     it.refforn ?? it.referencia ?? '',
            descricao:   it.descricao ?? '',
            condicao:    it.condicao ?? '',
            codvol:      it.codvol ?? 'UN',
            qtd:         Number(it.qtd ?? it.qtdneg) || 1,
            selecionado: true,
          }));
        this.gerarCompraCarregando = false;
        if (this.gerarCompraItens.length === 0) {
          this.gerarCompraErro = `O pedido de venda #${nunota} não possui itens válidos para gerar uma compra.`;
        }
      },
      error: (err: any) => {
        this.gerarCompraErro       = err?.error?.erro ?? err?.message ?? 'Erro ao carregar itens do pedido de venda.';
        this.gerarCompraCarregando = false;
      }
    });
  }

  fecharModalGerarCompra(): void {
    if (this.gerarCompraSalvando) return;
    this.modalGerarCompraAberto = false;
  }

  /**
   * Gera o(s) Pedido(s) de Compra a partir dos itens da venda/pré-venda pelo MESMO caminho da tela de Pedido de Compra
   * (gravarPedidoCompra: status ABERTO, tipo, Nº do pedido, cotação, espelho no Aerosys...). Preço = Preço do Fabricante.
   * Fabricante NACIONAL -> pedido NACIONAL (TOP 1300, valores em R$); demais -> IMPORTAÇÃO (TOP 1323, valores em U$).
   */
  async confirmarGerarPedidoCompra(): Promise<void> {
    if (!this.gerarCompraNunotaOrigem || this.gerarCompraSalvando) return;
    const origem = this.gerarCompraNunotaOrigem;
    const selecionados = this.gerarCompraItens.filter(i => i.selecionado && i.qtd > 0);
    if (selecionados.length === 0) {
      this.gerarCompraErro = 'Selecione ao menos um item.';
      return;
    }

    this.gerarCompraSalvando = true;
    this.gerarCompraErro     = '';
    try {
      // Empresa escolhida no modal (real; a virtual/fictícia vai junto quando for o caso)
      const opEmp = this.empresaState.opcoes.find(o => o.codEmp === this.gerarCompraEmpresaSel);
      const codEmpGerar = opEmp ? (opEmp.virtual ? Number(opEmp.codEmpReal) : Number(opEmp.codEmp)) : (Number(this.empresaState.codEmpReal ?? this.empresaState.selecionada) || 1);
      const empVirtualGerar = opEmp ? (opEmp.virtual ? Number(opEmp.codEmp) : 0) : (this.empresaState.selecionadaEhVirtual ? Number(this.empresaState.selecionada) : 0);
      // Cotação do dólar do dia (mais recente)
      let taxa = 0;
      try {
        const rc: any = await firstValueFrom(this.gw.buscarCotacoesDemonstrativo());
        const cot = (rc?.responseBody ?? rc)?.cotacoes ?? [];
        taxa = parseFloat(String(cot?.[0]?.valor ?? '').replace(',', '.')) || 0;
      } catch { /* sem cotação: segue só com os valores originais */ }

      // Itens (uma consulta por vez: o Sankhya recusa requisições simultâneas na mesma sessão)
      const grupos: Record<'NACIONAL' | 'IMPORTACAO', any[]> = { NACIONAL: [], IMPORTACAO: [] };
      for (const it of selecionados) {
        let preco = 0, nacional = false, codLocal = 95000000;
        try {
          const r: any = await firstValueFrom(this.gw.buscarPrecoExc(it.codprod, codEmpGerar));
          const body = r?.responseBody ?? r;
          const info = body?.info ?? body;
          preco = parseFloat(String(info?.vlrComerc ?? '0').replace(',', '.')) || 0;
          nacional = info?.origemNacional === true;
          const cl = Number(info?.codLocalPadrao ?? info?.codlocalpadrao ?? 0);
          if (cl > 0) codLocal = cl;
        } catch { /* sem preço: item vai com valor 0 e o comprador ajusta */ }
        const usd = nacional ? (taxa > 0 ? parseFloat((preco / taxa).toFixed(4)) : 0) : preco;
        const brl = nacional ? preco : parseFloat((preco * taxa).toFixed(2));
        grupos[nacional ? 'NACIONAL' : 'IMPORTACAO'].push({
          codprod: it.codprod,
          codvol: (it.codvol || 'UN').trim(),
          qtdneg: it.qtd,
          vlrunit: brl,
          percdesc: 0, vlrdesc: 0, vlracrescdesc: 0,
          codlocal: codLocal,
          vlrtot: parseFloat((brl * it.qtd).toFixed(2)),
          obsItem: '',
          statusItem: 'ABERTO',
          vlrunitmoe: usd,
          vlrtotmoe: parseFloat((usd * it.qtd).toFixed(2)),
          vlripi: 0, vlrsubst: 0, ad_core: 'N', ad_vlrcore: 0,
        });
      }

      // Comprador = o PRÓPRIO VENDEDOR da venda de origem (se ela não tiver, o do usuário logado; por fim o COMPRADOR genérico 24).
      let codVendLogado = this.gerarCompraCodVendOrigem;
      if (!codVendLogado) try {
        const rv: any = await firstValueFrom(this.gw.buscarVendedorLogadoPedidoVenda());
        const bv = rv?.responseBody ?? rv;
        codVendLogado = Number((bv?.vendedor ?? bv)?.codVend) || 0;
      } catch { /* cai no genérico */ }
      // Empresa = a da geração (selecionada no menu); empresa virtual (fictícia) vai junto quando for o caso.
      const FORNECEDOR_PADRAO = 7715;

      const hoje = new Date();
      const dataBr = `${String(hoje.getDate()).padStart(2, '0')}/${String(hoje.getMonth() + 1).padStart(2, '0')}/${hoje.getFullYear()}`;
      const gerados: string[] = [];
      const falhas: string[] = [];
      const avisosAerosys: string[] = [];
      for (const tipo of ['NACIONAL', 'IMPORTACAO'] as const) {
        const itens = grupos[tipo];
        if (itens.length === 0) continue;
        const payload = {
          cabecalho: {
            codEmp: codEmpGerar, empresaVirtual: empVirtualGerar,
            codParc: FORNECEDOR_PADRAO,       // fornecedor padrão; troca depois na edição do pedido
            codTipOper: tipo === 'NACIONAL' ? 1300 : 1323,
            codParcImp: tipo === 'NACIONAL' ? null : FORNECEDOR_PADRAO,
            codTipVenda: 1, codCenCus: 201000, codProj: 1000000000, codNat: 3010101,
            observacao: `Gerado a partir do Pedido de Venda #${origem}`,
            obsInterna: '', adObs: '', adFreteObs: '', numPedido2: '',
            mantemCotacao: 'S', tipoNumTitulo: 'PC',
            codVend: codVendLogado || 24,
            dataEmissao: dataBr, dtPrevent: '', dtNegociacao: dataBr,
            tipFrete: '', codParcTransp: null, cifFob: '', formaEnvio: '',
            qtdVol: null, pesoBruto: null, vlrFrete: null, vlrFreteTtl: null,
            prioridade: 'NORMAL', despachar: '', fatImediato: '',
            tipoGpl: tipo, gplStatus: 'ABERTO',
            codAero: null, codParcDest: null,
            vlrMoeda: taxa || null, vlrDescTot: null, percDesc: null,
          },
          itens,
        };
        try {
          const res: any = await firstValueFrom(this.gw.gravarPedidoCompra(payload) as any);
          const sb: any = res?.sankhya?.responseBody ?? res?.sankhya ?? res;
          if (sb?.sucesso === true || sb?.sucesso === 'true') {
            gerados.push(`#${sb?.nunota ?? ''} (${tipo === 'NACIONAL' ? 'Nacional' : 'Importação'})`);
            if (res?.aerosysOk === false) {
              const erros = (res?.aerosysBuckets ?? []).filter((x: any) => x?.ok === false).map((x: any) => x?.erro).filter(Boolean);
              avisosAerosys.push(`#${sb?.nunota ?? ''}: não foi possível espelhar no Aerosys${erros.length ? ' — ' + erros.join(' | ') : ''}`);
            }
          }
          else falhas.push(`${tipo}: ${sb?.erro ?? 'erro desconhecido'}`);
        } catch (err: any) {
          falhas.push(`${tipo}: ${err?.error?.detail ?? err?.error?.erro ?? err?.message ?? 'erro ao gravar'}`);
        }
      }

      if (falhas.length > 0 && gerados.length === 0) {
        this.gerarCompraErro = falhas.join(' | ');
        return;
      }
      this.modalGerarCompraAberto = false;
      this.mostrarToast(`✅ Pedido(s) de Compra gerado(s): ${gerados.join(', ')}${falhas.length ? ' — falhou: ' + falhas.join(' | ') : ''}${avisosAerosys.length ? ' — ATENÇÃO: ' + avisosAerosys.join(' | ') : ''}`);
      this.refreshLista();
    } finally {
      this.gerarCompraSalvando = false;
    }
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Modal "Gerar Venda a Partir da O.S" (Engrenagem da Lista de Pedidos de Venda)
  // Step 1: seleciona a empresa do Aerosys (cartões coloridos) — Step 2: lista as O.S. daquela empresa.
  // ══════════════════════════════════════════════════════════════════════════
  // O Aerosys usa EMP_ID (2, 6, 14, 18...) e o Sankhya usa CODEMP (1-7, 100) —
  // são espaços de ID diferentes, sem cruzamento cadastrado entre os dois
  // sistemas. Em vez de decodificar a cor Delphi bruta do Aerosys (o resultado
  // ficou com tons estranhos/escuros demais para cartão), reaproveitamos aqui
  // a mesma paleta já usada e aprovada no seletor de Empresas do menu
  // (EmpresaStateService.CORES), atribuída em ordem às empresas permitidas na
  // tela de O.S.
  private readonly OS_EMPRESA_CORES: Record<number, string> = {
    2:  '#D98D8B',
    6:  '#FFC000',
    14: '#92D050',
    18: '#AE99C7',
    19: '#FCD4B4',
    20: '#AEDCE8',
  };

  // Paleta de reserva — só usada se uma empresa não tiver cor cadastrada acima.
  private readonly OS_PALETA_CORES = [
    '#2563eb', '#d97706', '#059669', '#dc2626', '#7c3aed',
    '#0891b2', '#db2777', '#65a30d', '#ea580c', '#4f46e5'
  ];

  modalOsAberto = false;
  osStep: 1 | 2 = 1;
  osEmpresas: AerosysEmpresa[] = [];
  osEmpresasCarregando = false;
  osEmpresasErro = '';
  osEmpresaSelecionada: AerosysEmpresa | null = null;
  osLista: AerosysOrdemServico[] = [];
  osCarregando = false;
  osErro = '';
  osStartDate = '';
  osEndDate = '';

  // Cores dos badges de Status da O.S, seguindo a paleta já usada no Aerosys
  // (ordem importa: os termos mais específicos ficam antes dos genéricos, já
  // que a checagem é por "contém" — ex.: "pre-orcamento" antes de "orcamento").
  private readonly OS_STATUS_CORES: { contem: string; cor: string }[] = [
    { contem: 'cancelado',        cor: '#F5B7B1' },
    { contem: 'faturado',         cor: '#AEDCE8' },
    { contem: 'fechamento',       cor: '#FCD4B4' },
    { contem: 'pre-orcamento',    cor: '#FFF2A8' },
    { contem: 'ordem de servico', cor: '#D4CCF0' },
    { contem: 'orcamento',        cor: '#FFF2A8' },
  ];

  private _normalizarTexto(v: string): string {
    return v.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  /** Cor de fundo do badge de status, pela lista OS_STATUS_CORES (fallback: cinza neutro). */
  corOsStatus(status: string | null | undefined): string {
    const norm = this._normalizarTexto(status ?? '');
    const encontrado = this.OS_STATUS_CORES.find(s => norm.includes(s.contem));
    return encontrado?.cor ?? '#f1f5f9';
  }

  // Cores dos badges de Status da Venda (Sistema Legado/Aerosys), seguindo o
  // mesmo padrão de cores já usado no restante do sistema para esses status
  // (Pedido de Venda, Separação, Conferência etc.) — ordem importa: termos
  // mais específicos ficam antes dos genéricos ("separacao total" antes de
  // qualquer "separacao" isolado, por exemplo).
  private readonly VENDA_STATUS_CORES: { contem: string; cor: string }[] = [
    { contem: 'cancelado',        cor: '#F5B7B1' },
    { contem: 'separacao total',  cor: '#FFF2A8' },
    { contem: 'remessa',          cor: '#AEDCE8' },
    { contem: 'finalizado',       cor: '#FFF2A8' },
    { contem: 'pronto',           cor: '#4CAF50' },
    { contem: 'pendente',         cor: '#FCD4B4' },
    { contem: 'autorizado',       cor: '#FFF2A8' },
    { contem: 'aberto',           cor: '#f1f5f9' },
  ];

  /** Cor de fundo do badge de status da Venda, pela lista VENDA_STATUS_CORES (fallback: cinza neutro). */
  corVendaStatus(status: string | null | undefined): string {
    const norm = this._normalizarTexto(status ?? '');
    const encontrado = this.VENDA_STATUS_CORES.find(s => norm.includes(s.contem));
    return encontrado?.cor ?? '#f1f5f9';
  }

  /** "Pronto" tem fundo verde escuro — usa texto branco para contraste (as demais cores são pasteis claras). */
  corVendaStatusTexto(status: string | null | undefined): string {
    const norm = this._normalizarTexto(status ?? '');
    return norm.includes('pronto') ? '#ffffff' : '#334155';
  }

  /** Não é permitido gerar venda a partir de uma O.S cancelada. */
  isOsCancelada(status: string | null | undefined): boolean {
    return this._normalizarTexto(status ?? '').includes('cancelado');
  }

  corOsEmpresa(id: number | string | undefined): string {
    const n = Math.trunc(Number(id) || 0);
    const corReal = this.OS_EMPRESA_CORES[n];
    if (corReal) {
      return corReal;
    }
    const idx = Math.abs(n) % this.OS_PALETA_CORES.length;
    return this.OS_PALETA_CORES[idx];
  }

  corOsEmpresaClara(id: number | string | undefined, fator = 0.82): string {
    const hex = this.corOsEmpresa(id).replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const rr = Math.round(r + (255 - r) * fator).toString(16).padStart(2, '0');
    const gg = Math.round(g + (255 - g) * fator).toString(16).padStart(2, '0');
    const bb = Math.round(b + (255 - b) * fator).toString(16).padStart(2, '0');
    return `#${rr}${gg}${bb}`;
  }

  /** IDs das empresas do Aerosys que devem aparecer na seleção (demais ficam ocultas). */
  private readonly OS_EMPRESAS_PERMITIDAS = [2, 6, 14, 18, 19, 20];

  /** Filtro de texto (Cliente, Status, Aeronave, Nº O.S, Tipo) sobre a lista de O.S já carregada. */
  osFiltroTexto = '';

  get osListaFiltrada(): AerosysOrdemServico[] {
    const termo = this.osFiltroTexto.trim().toLowerCase();
    if (!termo) return this.osLista;
    return this.osLista.filter(os =>
      (os.clienteNome ?? '').toLowerCase().includes(termo) ||
      (os.status ?? '').toLowerCase().includes(termo) ||
      (os.aeronaveMatricula ?? '').toLowerCase().includes(termo) ||
      (os.numOs ?? '').toLowerCase().includes(termo) ||
      (os.tipo ?? '').toLowerCase().includes(termo)
    );
  }

  /** Engrenagem da Lista de Pedidos de Venda → "Gerar Venda a Partir da O.S". */
  onSolicitarGerarVendaOS(): void {
    this.modalOsAberto = true;
    this.osStep = 1;
    this.osEmpresaSelecionada = null;
    this.osLista = [];
    this.osErro = '';
    this.osFiltroTexto = '';

    if (!this.osStartDate) {
      const hoje = new Date();
      const inicio = new Date(hoje.getFullYear(), hoje.getMonth() - 1, hoje.getDate());
      this.osStartDate = this._formatarDataInput(inicio);
      this.osEndDate = this._formatarDataInput(hoje);
    }

    if (this.osEmpresas.length === 0 && !this.osEmpresasCarregando) {
      this.carregarOsEmpresas();
    }
  }

  private _formatarDataInput(d: Date): string {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  /** <input type="date"> entrega yyyy-MM-dd; a API do Aerosys espera dd-MM-yyyy. */
  private _paraFormatoAerosys(dataInput: string): string {
    const [yyyy, mm, dd] = dataInput.split('-');
    return `${dd}-${mm}-${yyyy}`;
  }

  carregarOsEmpresas(): void {
    this.osEmpresasCarregando = true;
    this.osEmpresasErro = '';
    this.aerosysGateway.listarEmpresas().subscribe({
      next: (lista) => {
        const todas = Array.isArray(lista) ? lista : [];
        this.osEmpresas = todas.filter(e => this.OS_EMPRESAS_PERMITIDAS.includes(Number(e.id)));
        this.osEmpresasCarregando = false;
      },
      error: (err: any) => {
        this.osEmpresasErro = err?.error?.detail ?? err?.message ?? 'Erro ao carregar empresas do Aerosys.';
        this.osEmpresasCarregando = false;
      }
    });
  }

  selecionarOsEmpresa(empresa: AerosysEmpresa): void {
    this.osEmpresaSelecionada = empresa;
    this.osStep = 2;
    this.osFiltroTexto = '';
    this.buscarOrdensServico();
  }

  buscarOrdensServico(): void {
    if (!this.osEmpresaSelecionada) return;
    this.osCarregando = true;
    this.osErro = '';
    this.osLista = [];

    const start = this._paraFormatoAerosys(this.osStartDate);
    const end = this._paraFormatoAerosys(this.osEndDate);

    this.aerosysGateway.listarOrdensServico(this.osEmpresaSelecionada.id, start, end).subscribe({
      next: (lista) => {
        this.osLista = Array.isArray(lista) ? lista : [];
        this.osCarregando = false;
      },
      error: (err: any) => {
        this.osErro = err?.error?.detail ?? err?.message ?? 'Erro ao buscar Ordens de Serviço.';
        this.osCarregando = false;
      }
    });
  }

  voltarOsEmpresas(): void {
    this.osStep = 1;
    this.osEmpresaSelecionada = null;
    this.osLista = [];
    this.osErro = '';
    this.osFiltroTexto = '';
  }

  fecharModalOs(): void {
    if (this.osCarregando) return;
    this.modalOsAberto = false;
  }

  osDetalheCarregando = false;

  /** Busca o Part Number de cada item da O.S. e abre um Pedido de Venda novo
   *  com os itens já em revisão (reaproveita a importação de Excel). */
  onSelecionarOrdemServico(os: AerosysOrdemServico): void {
    if (!this.osEmpresaSelecionada || this.osDetalheCarregando) return;
    if (this.isOsCancelada(os.status)) {
      this.mostrarToast(`A O.S. ${os.numOs ?? os.id} está cancelada — não é possível gerar venda a partir dela.`, 6000);
      return;
    }
    const empresa = this.osEmpresaSelecionada;
    this.osDetalheCarregando = true;

    this.aerosysGateway.buscarOrdemServico(empresa.id, os.id).subscribe({
      next: (detalhe) => {
        this.osDetalheCarregando = false;

        const itens = (detalhe.listaItens ?? [])
          .map(i => ({
            pn: String(i.partNumber ?? '').trim(),
            quantidade: Number(i.quant) > 0 ? Number(i.quant) : 1
          }))
          .filter(i => i.pn.length > 0);

        if (itens.length === 0) {
          this.mostrarToast(
            `A O.S. ${os.numOs ?? os.id} não possui itens com Part Number preenchido.`,
            6000
          );
          return;
        }

        const nomeEmpresa = empresa.nome || empresa.razao || ('Empresa ' + empresa.id);
        this.itensImportarDeOS.set(itens);
        this.observacaoImportarDeOS.set(
          `Gerado a partir da O.S #${os.numOs ?? os.id} (Aerosys — ${nomeEmpresa})`
        );
        this.origemOSImportar.set({
          numOs: os.numOs ?? os.id,
          empresaNome: nomeEmpresa,
          clienteNome: os.clienteNome,
          aeronaveMatricula: os.aeronaveMatricula
        });

        this.modalOsAberto = false;
        this.pedidoEditando.set(null);
        this.modoPreVenda.set(false);
        this.activeView.set('pedido-venda');
      },
      error: (err: any) => {
        this.osDetalheCarregando = false;
        this.mostrarToast(
          err?.error?.detail ?? err?.message ?? 'Erro ao carregar itens da O.S.',
          6000
        );
      }
    });
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Gerar Venda a Partir de Sistema Legado — o "Sistema Legado" é o próprio
  // Aerosys, mas a partir de VENDAS (não O.S). Mesmo fluxo/UX do modal de O.S
  // acima (empresa por cor -> lista -> seleção -> importa itens), só que a
  // lista de empresas mostra apenas os ids do Aerosys usados para Vendas.
  // ══════════════════════════════════════════════════════════════════════════
  modalVendaLegadoAberto = false;
  vendaLegadoStep: 1 | 2 = 1;
  vendaLegadoEmpresas: AerosysEmpresa[] = [];
  vendaLegadoEmpresasCarregando = false;
  vendaLegadoEmpresasErro = '';
  vendaLegadoEmpresaSelecionada: AerosysEmpresa | null = null;
  vendaLegadoLista: AerosysVenda[] = [];
  vendaLegadoCarregando = false;
  vendaLegadoErro = '';
  vendaLegadoStartDate = '';
  vendaLegadoEndDate = '';
  vendaLegadoFiltroTexto = '';
  vendaLegadoDetalheCarregando = false;

  /** IDs das empresas do Aerosys que devem aparecer na seleção de Vendas
   *  (lista diferente da O.S, que mostra outro subconjunto de empresas). */
  private readonly VENDA_LEGADO_EMPRESAS_PERMITIDAS = [1, 3, 5, 7, 8, 9, 13, 15, 17];

  get vendaLegadoListaFiltrada(): AerosysVenda[] {
    const termo = this.vendaLegadoFiltroTexto.trim().toLowerCase();
    if (!termo) return this.vendaLegadoLista;
    return this.vendaLegadoLista.filter(v =>
      (v.clienteNome ?? '').toLowerCase().includes(termo) ||
      (v.status ?? '').toLowerCase().includes(termo) ||
      (v.numTitulo ?? '').toLowerCase().includes(termo) ||
      (v.tipo ?? '').toLowerCase().includes(termo)
    );
  }

  /** Engrenagem da Lista de Pedidos de Venda → "Gerar Venda a Partir de Sistema Legado". */
  onSolicitarGerarVendaLegado(): void {
    this.modalVendaLegadoAberto = true;
    this.vendaLegadoStep = 1;
    this.vendaLegadoEmpresaSelecionada = null;
    this.vendaLegadoLista = [];
    this.vendaLegadoErro = '';
    this.vendaLegadoFiltroTexto = '';

    if (!this.vendaLegadoStartDate) {
      // Últimos 10 dias por padrão — período maior (antes 30 dias, e antes disso
      // 6 meses) trazia vendas demais de uma vez, deixando a lista (e a API do
      // Aerosys) lenta. O usuário ainda pode ampliar o período manualmente nos
      // campos de data quando precisar de um intervalo maior.
      const hoje = new Date();
      const inicio = new Date(hoje);
      inicio.setDate(inicio.getDate() - 10);
      this.vendaLegadoStartDate = this._formatarDataInput(inicio);
      this.vendaLegadoEndDate = this._formatarDataInput(hoje);
    }

    if (this.vendaLegadoEmpresas.length === 0 && !this.vendaLegadoEmpresasCarregando) {
      this.carregarVendaLegadoEmpresas();
    }
  }

  carregarVendaLegadoEmpresas(): void {
    this.vendaLegadoEmpresasCarregando = true;
    this.vendaLegadoEmpresasErro = '';
    this.aerosysGateway.listarEmpresas().subscribe({
      next: (lista) => {
        const todas = Array.isArray(lista) ? lista : [];
        this.vendaLegadoEmpresas = todas.filter(e => this.VENDA_LEGADO_EMPRESAS_PERMITIDAS.includes(Number(e.id)));
        this.vendaLegadoEmpresasCarregando = false;
      },
      error: (err: any) => {
        this.vendaLegadoEmpresasErro = err?.error?.detail ?? err?.message ?? 'Erro ao carregar empresas do Aerosys.';
        this.vendaLegadoEmpresasCarregando = false;
      }
    });
  }

  selecionarVendaLegadoEmpresa(empresa: AerosysEmpresa): void {
    this.vendaLegadoEmpresaSelecionada = empresa;
    this.vendaLegadoStep = 2;
    this.vendaLegadoFiltroTexto = '';
    this.buscarVendasLegado();
  }

  buscarVendasLegado(): void {
    if (!this.vendaLegadoEmpresaSelecionada) return;
    this.vendaLegadoCarregando = true;
    this.vendaLegadoErro = '';
    this.vendaLegadoLista = [];

    const start = this._paraFormatoAerosys(this.vendaLegadoStartDate);
    const end = this._paraFormatoAerosys(this.vendaLegadoEndDate);

    this.aerosysGateway.listarVendas(this.vendaLegadoEmpresaSelecionada.id, start, end).subscribe({
      next: (lista) => {
        // Traz qualquer STATUS agora (antes filtrava só "Aberto") — só
        // continua excluindo Categoria (campo "Tipo") = Transferência, que
        // não é uma venda de verdade.
        const listaBruta = Array.isArray(lista) ? lista : [];
        this.vendaLegadoLista = listaBruta.filter(v => {
          const tipo = this._normalizarTexto(v.tipo ?? '');
          return !tipo.includes('transferencia');
        });
        this.vendaLegadoCarregando = false;
      },
      error: (err: any) => {
        this.vendaLegadoErro = err?.error?.detail ?? err?.message ?? 'Erro ao buscar Vendas.';
        this.vendaLegadoCarregando = false;
      }
    });
  }

  voltarVendaLegadoEmpresas(): void {
    this.vendaLegadoStep = 1;
    this.vendaLegadoEmpresaSelecionada = null;
    this.vendaLegadoLista = [];
    this.vendaLegadoErro = '';
    this.vendaLegadoFiltroTexto = '';
  }

  fecharModalVendaLegado(): void {
    if (this.vendaLegadoCarregando) return;
    this.modalVendaLegadoAberto = false;
  }

  /** Busca o Part Number (via adendoPecas.pn) de cada item da Venda e abre um Pedido
   *  de Venda novo com os itens já em revisão — reaproveita o mesmo mecanismo de
   *  importação (itensImportarDeOS/observacaoImportarDeOS/origemOSImportar) já usado
   *  em "Gerar Venda a Partir da O.S", já que o formato de itens é o mesmo. */
  onSelecionarVendaLegado(venda: AerosysVenda): void {
    if (!this.vendaLegadoEmpresaSelecionada || this.vendaLegadoDetalheCarregando) return;
    if (this.isOsCancelada(venda.status)) {
      this.mostrarToast(`A Venda ${venda.numTitulo ?? venda.id} está cancelada — não é possível gerar venda a partir dela.`, 6000);
      return;
    }
    const empresa = this.vendaLegadoEmpresaSelecionada;
    this.vendaLegadoDetalheCarregando = true;

    this.aerosysGateway.buscarVenda(empresa.id, venda.id).subscribe({
      next: (detalhe) => {
        this.vendaLegadoDetalheCarregando = false;

        const itens = (detalhe.listaItens ?? [])
          .map(i => {
            // CORRIGIDO (confirmado pelo usuário): no Aerosys, acréscimo vem como
            // -valor (negativo) e desconto vem sem sinal (positivo) — ou seja, a
            // MESMA convenção que já usamos aqui (vlrDesc positivo = desconto,
            // negativo = acréscimo). A versão anterior deste código invertia o
            // sinal partindo do pressuposto contrário (errado), o que fazia
            // descontos legítimos virarem acréscimos internamente e vice-versa —
            // gerando itens com % de desconto/acréscimo desproporcional e
            // disparando "Valor da substituição não pode ficar negativo" no save
            // nativo. Sem inversão agora: repassamos o valor do Aerosys direto.
            const descAcresAerosys = Number(i.descAcres ?? 0);
            return {
              pn: String(i.adendoPecas?.pn ?? '').trim(),
              quantidade: Number(i.quant) > 0 ? Number(i.quant) : 1,
              vlrDescAcresc: descAcresAerosys !== 0 ? descAcresAerosys : undefined
            };
          })
          .filter(i => i.pn.length > 0);

        if (itens.length === 0) {
          this.mostrarToast(
            `A Venda ${venda.numTitulo ?? venda.id} não possui itens com Part Number preenchido.`,
            6000
          );
          return;
        }

        const nomeEmpresa = empresa.nome || empresa.razao || ('Empresa ' + empresa.id);
        this.itensImportarDeOS.set(itens);
        this.observacaoImportarDeOS.set(
          `Gerado a partir da Venda #${venda.numTitulo ?? venda.id} (Aerosys — ${nomeEmpresa})`
        );
        // A "Venda" do Aerosys (ao contrário da O.S., que tem aeronaveMatricula
        // tipado) não tem um campo de aeronave definido na nossa interface
        // AerosysVenda/AerosysVendaDetalhe — por isso o Prefixo nunca vinha
        // preenchido ao gerar venda a partir do Sistema Legado. Como não temos
        // confirmação de qual chave a API do Aerosys usa nesse endpoint,
        // tentamos as variantes mais prováveis nos dois objetos (resumo e
        // detalhe) antes de desistir — se nenhuma bater, populamos vazio como
        // antes (sem quebrar o fluxo), mas isso precisa ser confirmado/ajustado
        // com uma amostra real do JSON de /venda/{empresa}/{id}.
        const aeronaveMatricula = String(
          (detalhe as any)?.aeronaveMatricula ??
          (detalhe as any)?.aeronave ??
          (detalhe as any)?.prefixoAeronave ??
          (detalhe as any)?.matriculaAeronave ??
          (venda as any)?.aeronaveMatricula ??
          ''
        ).trim();
        this.origemOSImportar.set({
          numOs: venda.numTitulo ?? venda.id,
          empresaNome: nomeEmpresa,
          clienteNome: venda.clienteNome,
          aeronaveMatricula: aeronaveMatricula || undefined
        });

        this.modalVendaLegadoAberto = false;
        this.pedidoEditando.set(null);
        this.modoPreVenda.set(false);
        this.activeView.set('pedido-venda');
      },
      error: (err: any) => {
        this.vendaLegadoDetalheCarregando = false;
        this.mostrarToast(
          err?.error?.detail ?? err?.message ?? 'Erro ao carregar itens da Venda.',
          6000
        );
      }
    });
  }

  onIniciarSeparacao(nunota: number): void {
    this.separacaoNunota.set(nunota);
    this.navigate('estoque-separacao-itens');
  }

  onVoltarSeparacaoLista(): void {
    this.separacaoNunota.set(null);
    this.navigate('estoque-separacao');
  }

  onSeparacaoFinalizada(): void {
    this.separacaoNunota.set(null);
    this.navigate('estoque-separacao');
  }

  /** "Continuar Separação" clicado num card do Sistema Legado (Aerosys) — ver
   *  iniciarLegado em estoque-separacao.component.ts. Fluxo isolado do Sankhya:
   *  usa a tela estoque-separacao-itens-legado, sem validação de posse. */
  onIniciarSeparacaoLegado(evt: { idVenda: number; numVenda?: string }): void {
    this.separacaoLegadoIdVenda.set(evt.idVenda);
    this.separacaoLegadoNumVenda.set(evt.numVenda);
    this.navigate('estoque-separacao-itens-legado');
  }

  onVoltarSeparacaoLegadoLista(): void {
    this.separacaoLegadoIdVenda.set(null);
    this.navigate('estoque-separacao');
  }

  onSeparacaoLegadoFinalizada(): void {
    this.separacaoLegadoIdVenda.set(null);
    this.navigate('estoque-separacao');
  }

  onIniciarConferencia(nunota: number): void {
    this.conferenciaNunota.set(nunota);
    this.navigate('estoque-conferencia-itens');
  }

  onVoltarConferenciaLista(): void {
    this.conferenciaNunota.set(null);
    this.navigate('estoque-conferencia');
  }

  onConferenciaFinalizada(): void {
    this.conferenciaNunota.set(null);
    this.navigate('estoque-conferencia');
  }

  /** "Continuar/Iniciar Conferência" clicado num card do Sistema Legado (Aerosys) — ver
   *  continuarOuIniciarLegado em estoque-conferencia.component.ts. Fluxo isolado do
   *  Sankhya: usa a tela estoque-conferencia-itens-legado, sem validação de posse. */
  onIniciarConferenciaLegado(evt: { idVenda: number; numVenda?: string }): void {
    this.conferenciaLegadoIdVenda.set(evt.idVenda);
    this.conferenciaLegadoNumVenda.set(evt.numVenda);
    this.navigate('estoque-conferencia-itens-legado');
  }

  onVoltarConferenciaLegadoLista(): void {
    this.conferenciaLegadoIdVenda.set(null);
    this.navigate('estoque-conferencia');
  }

  onConferenciaLegadoFinalizada(): void {
    this.conferenciaLegadoIdVenda.set(null);
    this.navigate('estoque-conferencia');
  }

  onPendenciaEnviada(): void {
    this.conferenciaNunota.set(null);
    // O pedido saiu da fila de Conferência (foi pra PENDENCIA VENDEDOR),
    // então a navegação natural é para a fila de Conferência Pendente, não
    // de volta pra fila de Conferência de onde ele acabou de sair.
    this.navigate('conferencia-pendente');
  }

  onVerItensPendencia(nunota: number): void {
    this.pendenciaVendedorNunota.set(nunota);
    this.navigate('conferencia-pendente-itens');
  }

  onVoltarPendenciaLista(): void {
    this.pendenciaVendedorNunota.set(null);
    this.navigate('conferencia-pendente');
  }

  onPendenciaResolvida(): void {
    this.pendenciaVendedorNunota.set(null);
    this.navigate('conferencia-pendente');
  }

  onEditarVendaDePendencia(nunota: number): void {
    this.onEditarPedido(nunota);
  }

  onVisualizarItensLogistica(nunota: number): void {
    this.logisticaNunota.set(nunota);
    this.navigate('estoque-logistica-itens');
  }

  onVoltarLogisticaLista(): void {
    this.logisticaNunota.set(null);
    this.navigate('estoque-logistica');
  }

  onLogisticaFinalizada(): void {
    this.logisticaNunota.set(null);
    this.navigate('estoque-logistica');
  }

  onVoltarLista(): void {
    this.pedidoEditando.set(null);
    this.itensImportarDeOS.set(null);
    this.observacaoImportarDeOS.set(null);
    this.origemOSImportar.set(null);
    this.acaoStatusImportar.set(null);
    this.activeView.set(this._vLista());
    setTimeout(() => this.listaAtiva?.buscar(), 50);
  }


  impressaoCompra = signal<ImpressaoCompraSelecao | null>(null);

  onImprimirCompra(selecao: ImpressaoCompraSelecao): void {
    this.impressaoCompra.set(selecao);
  }

  fecharImpressaoCompra(): void {
    this.impressaoCompra.set(null);
  }

  impressaoPedido = signal<number | null>(null);

  onImprimirPedido(nunota: number): void {
    try {
      const storage = window.top?.sessionStorage || window.sessionStorage;
      storage?.setItem('param_venda_impressao_nunota', String(nunota));
    } catch {}
    this.impressaoPedido.set(nunota);
  }

  fecharImpressao(): void {
    this.impressaoPedido.set(null);
  }

  // ── Toast ─────────────────────────────────────────────────────────────────
  toastVisivel  = false;
  toastMensagem = '';
  private _toastTimer: ReturnType<typeof setTimeout> | null = null;

  mostrarToast(msg: string, ms = 4000): void {
    if (this._toastTimer) clearTimeout(this._toastTimer);
    
    // Limita o tempo máximo para 4 segundos, mesmo se passado um valor maior
    ms = Math.min(ms, 4000);
    
    let linhas = (msg || '').split(' | ');
    if (linhas.length > 6) {
      this.toastMensagem = linhas.slice(0, 6).join('\n') + `\n\n... e mais ${linhas.length - 6} itens (veja mais detalhes abrindo o pedido).`;
    } else {
      this.toastMensagem = linhas.join('\n');
    }
    this.toastVisivel  = true;
    this._toastTimer = setTimeout(() => { this.toastVisivel = false; }, ms);
  }

  // ── Atribuição automática de Seriais e Lotes ─────────────────────────────
  private atribuirControlesAutomaticos(nunota: number): void {
    let msgSeriais = '';
    let msgLotes   = '';
    let pendentes  = 2; // aguarda as duas chamadas

    const concluir = () => {
      pendentes--;
      if (pendentes > 0) return;
      const partes = [msgSeriais, msgLotes].filter(m => !!m);
      if (partes.length > 0) {
        this.mostrarToast(`✅ Orçamento #${nunota} convertido!\n${partes.join('\n')}`, 12000);
      } else {
        this.mostrarToast(`✅ Orçamento #${nunota} convertido para Pedido de Venda com sucesso!`, 8000);
      }
      // Confirma o movimento no motor nativo do Sankhya (CACSP.confirmarNota) DEPOIS
      // de seriais/lotes atribuídos — é essa chamada que numera a nota (Nro. Nota),
      // monta a reserva de estoque conforme a TOP e gera o financeiro.
      this.confirmarMovimentoNativo(nunota);
    };

    this.serialService.atribuirSeriaisAutomaticos(nunota).subscribe({
      next: (res: any) => {
        const b = res?.responseBody ?? res;
        if (b?.sucesso === false) {
          msgSeriais = `Aviso seriais: ${b?.erro ?? 'Erro desconhecido'}`;
        } else {
          const lista = (b?.atribuidos ?? []).map((s: any) => s.controle ?? s.serie).filter(Boolean);
          if (lista.length) msgSeriais = `Seriais: ${lista.join(', ')}`;
          const avisos = (b?.avisos ?? []).map((a: any) => a.aviso).filter(Boolean);
          if (avisos.length) msgSeriais += (msgSeriais ? ' | ' : '') + `Sem estoque: ${avisos.join('; ')}`;
        }
        concluir();
      },
      error: () => { msgSeriais = 'Aviso: não foi possível atribuir seriais.'; concluir(); }
    });

    this.loteService.atribuirLotesAutomaticos(nunota).subscribe({
      next: (res: any) => {
        const b = res?.responseBody ?? res;
        if (b?.sucesso === false) {
          msgLotes = `Aviso lotes: ${b?.erro ?? 'Erro desconhecido'}`;
        } else {
          const lista = (b?.atribuidos ?? []).map((l: any) => l.controle).filter(Boolean);
          if (lista.length) msgLotes = `Lotes: ${lista.join(', ')}`;
          const avisos = (b?.avisos ?? []).map((a: any) => a.aviso).filter(Boolean);
          if (avisos.length) msgLotes += (msgLotes ? ' | ' : '') + `Sem estoque: ${avisos.join('; ')}`;
        }
        concluir();
      },
      error: () => { msgLotes = 'Aviso: não foi possível atribuir lotes.'; concluir(); }
    });
  }

  /**
   * Troca a TOP do pedido (1000 Orçamento → 1001 Pedido de Venda). Só depois disso
   * segue para atribuir seriais/lotes e confirmar a nota.
   *
   * O serviço nativo CACSP.incluirAlterarCabecalhoNota (o mesmo que a tela nativa
   * usa ao editar o Tipo de Operação e salvar) está retornando "Sem mensagem de
   * erro" de forma consistente nesse ambiente via API — chamado aberto com o
   * suporte Sankhya pra investigar. Enquanto isso, usamos um UPDATE controlado no
   * addon GPL que troca CODTIPOPER e sincroniza RESERVA/ATUALESTOQUE dos itens na
   * mesma transação (sem tocar STATUSNOTA) — evita tanto a reserva inconsistente
   * (ORA-20101, gatilho TRG_UPT_TGFITE) quanto o "nota já confirmada" que um
   * UPDATE puro antigo causava. A confirmação de verdade continua sendo feita
   * depois, pelo motor nativo CACSP.confirmarNota.
   */
  private converterOrcamentoEmPedidoNativo(nunota: number): void {
    this.gw.alterarTopComReservaPedidoVenda(nunota, 1001).subscribe({
      next: (res: any) => {
        const body = res?.responseBody ?? res;
        if (body?.sucesso === true || body?.sucesso === 'true') {
          this.atribuirControlesAutomaticos(nunota);
        } else {
          const msg = body?.erro ?? 'Erro desconhecido ao trocar a TOP do pedido.';
          this.mostrarToast(
            `⚠️ Pedido #${nunota} autorizado, mas houve falha ao converter para Pedido de Venda: ${msg}`,
            15000
          );
        }
      },
      error: (err: any) => {
        const msg = err?.error?.erro ?? err?.message ?? 'Erro de comunicação.';
        this.mostrarToast(
          `⚠️ Pedido #${nunota} autorizado, mas houve falha ao converter para Pedido de Venda: ${msg}`,
          15000
        );
      }
    });
  }

  /**
   * Confirma o pedido de venda no motor nativo do Sankhya (CACSP.confirmarNota)
   * — o mesmo serviço que a tela nativa usa no botão "Confirmar". É essa chamada
   * que efetivamente numera a nota (Nro. Nota), monta a reserva de estoque
   * conforme a TOP e gera os títulos financeiros. Sem ela, o pedido fica
   * "AUTORIZADO" no GPL mas sem Nro. Nota, travando o faturamento depois.
   */
  private confirmarMovimentoNativo(nunota: number): void {
    this.gw.confirmarMovimentoPedidoVenda(nunota).subscribe({
      next: (res: any) => {
        const body = res?.responseBody ?? res;
        if (body?.sucesso === true || body?.sucesso === 'true') {
          this.mostrarToast(`📄 Pedido #${nunota} confirmado — Nro. Nota gerado.`, 8000);
          setTimeout(() => this.listaAtiva?.buscar(), 300);
        } else {
          const msg = body?.erro ?? 'Erro desconhecido ao confirmar a nota.';
          this.mostrarToast(
            `⚠️ Pedido #${nunota} autorizado, mas houve falha ao gerar o Nro. Nota: ${msg}`,
            15000
          );
        }
      },
      error: (err: any) => {
        const msg = err?.error?.erro ?? err?.message ?? 'Erro de comunicação.';
        this.mostrarToast(
          `⚠️ Pedido #${nunota} autorizado, mas houve falha ao gerar o Nro. Nota: ${msg}`,
          15000
        );
      }
    });
  }

  // ── Refresh lista ─────────────────────────────────────────────────────────
  private refreshLista(): void {
    if (this.activeView() === 'pedido-venda-lista' || this.activeView() === 'pre-venda-lista') {
      this.listaAtiva?.buscar();
    }
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Modal Duplicar Venda
  // ══════════════════════════════════════════════════════════════════════════
  modalDuplicarAberto     = false;
  duplicarNunota: number | null = null;
  duplicarStep            = 1;
  duplicarErro            = '';
  duplicarCarregando      = false;
  duplicarItensCarregando = false;
  empDuplicarSelecionada: string | null = null;
  duplicarItens: DuplicarItem[] = [];

  /** Empresas 2 e 100 ficam fora da seleção de destino do Clonar (não podem ser destino de clonagem). */
  get duplicarEmpresasOpcoes(): EmpresaOpcao[] {
    return this.empresaState.opcoes.filter(e => e.codEmp !== '2' && e.codEmp !== '100');
  }

  get duplicarTodosSelecionados(): boolean {
    return this.duplicarItens.length > 0 && this.duplicarItens.every(i => i.selecionado);
  }

  toggleTodosItens(selecionado: boolean): void {
    this.duplicarItens.forEach(i => i.selecionado = selecionado);
  }

  onSolicitarDuplicarPedido(nunota: number): void {
    this.duplicarNunota          = nunota;
    this.duplicarStep            = 1;
    this.duplicarErro            = '';
    this.duplicarCarregando      = false;
    this.duplicarItensCarregando = false;
    this.empDuplicarSelecionada  = null;
    this.duplicarItens           = [];
    this.modalDuplicarAberto     = true;
    this.empresaState.carregar();
  }

  fecharModalDuplicar(): void {
    if (this.duplicarCarregando || this.duplicarItensCarregando) return;
    this.modalDuplicarAberto = false;
  }

  confirmarDuplicar(): void {
    if (!this.empDuplicarSelecionada || !this.duplicarNunota) return;

    if (this.duplicarStep === 1) {
      // Avançar para seleção de itens
      this.duplicarItensCarregando = true;
      this.duplicarErro = '';
      this.gw.buscarDetalhesPedidoVenda(this.duplicarNunota).subscribe({
        next: (res: any) => {
          const body  = res?.responseBody ?? res;
          const det   = body?.detalhe ?? body;
          const itens: any[] = det?.itens ?? [];
          this.duplicarItens = itens.map((it: any) => ({
            seq:        it.seq       ?? 0,
            codprod:    it.codprod   ?? 0,
            descricao:  it.descricao ?? '',
            refforn:    it.refforn   ?? '',
            condicao:   it.condicao  ?? '',
            qtd:        Number(it.qtd ?? 0),
            selecionado: true,
          }));
          this.duplicarStep            = 2;
          this.duplicarItensCarregando = false;
        },
        error: (err: any) => {
          this.duplicarErro            = err?.error?.erro ?? err?.message ?? 'Erro ao carregar itens.';
          this.duplicarItensCarregando = false;
        }
      });
      return;
    }

    // Step 2: executar duplicação
    const seqs = this.duplicarItens.filter(i => i.selecionado).map(i => i.seq);
    if (seqs.length === 0) { this.duplicarErro = 'Selecione ao menos um item.'; return; }

    this.duplicarCarregando = true;
    this.duplicarErro       = '';
    this.gw.duplicarPedidoVenda(this.duplicarNunota!, Number(this.empDuplicarSelecionada), seqs).subscribe({
      next: (res: any) => {
        this.duplicarCarregando  = false;
        this.modalDuplicarAberto = false;
        const body       = res?.responseBody ?? res;
        const novoNunota = body?.nunotaNova ?? body?.nunota;
        let msg = novoNunota ? `Pedido clonado! Abrindo nova venda #${novoNunota}...` : 'Pedido clonado com sucesso!';
        if (body?.avisoTgfvar) msg += ' ⚠ ' + body.avisoTgfvar;
        this.mostrarToast(msg);
        if (novoNunota) {
          // Troca empresa de destino antes de abrir a venda duplicada
          if (this.empDuplicarSelecionada && this.empDuplicarSelecionada !== this.empresaState.selecionada) {
            this.empresaState.selecionada = this.empDuplicarSelecionada;
          }
          this.onEditarPedido(Number(novoNunota));
        } else {
          this.refreshLista();
        }
      },
      error: (err: any) => {
        this.duplicarCarregando = false;
        this.duplicarErro       = err?.error?.erro ?? err?.message ?? 'Erro ao duplicar pedido.';
      }
    });
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Modal Dividir Venda
  // ══════════════════════════════════════════════════════════════════════════
  modalDividirAberto     = false;
  dividirNunota: number | null = null;
  dividirErro            = '';
  dividirCarregando      = false;
  dividirItensCarregando = false;
  dividirItens: DividirItem[] = [];
  dividirAvisoAberto     = false;
  dividirAvisoItensTotal: DividirItem[] = [];

  get dividirItensNova(): DividirItem[] {
    return this.dividirItens.filter(i => i.qtdParaMover > 0);
  }

  get dividirTotalUnidadesNova(): number {
    return this.dividirItensNova.reduce((s, i) => s + i.qtdParaMover, 0);
  }

  get origemFicariaSemItens(): boolean {
    return this.dividirItens.length > 0 &&
      this.dividirItens.every(i => i.qtdParaMover >= i.qtdOriginal);
  }

  get dividirPreviewOrigem(): { descricao: string; qtd: number }[] {
    return this.dividirItens
      .filter(i => (i.qtdOriginal - i.qtdParaMover) > 0)
      .map(i => ({ descricao: i.descricao, qtd: i.qtdOriginal - i.qtdParaMover }));
  }

  get dividirPreviewDestino(): { descricao: string; qtd: number }[] {
    return this.dividirItensNova.map(i => ({ descricao: i.descricao, qtd: i.qtdParaMover }));
  }

  get dividirAvisoItensNomes(): string {
    return this.dividirAvisoItensTotal.map(i => i.descricao).join(', ');
  }

  onSolicitarDividirPedido(nunota: number): void {
    this.dividirNunota          = nunota;
    this.dividirErro            = '';
    this.dividirCarregando      = false;
    this.dividirAvisoAberto     = false;
    this.dividirAvisoItensTotal = [];
    this.dividirItens           = [];
    this.modalDividirAberto     = true;
    this._carregarItensDividir(nunota);
  }

  private _carregarItensDividir(nunota: number): void {
    this.dividirItensCarregando = true;
    this.gw.buscarDetalhesPedidoVenda(nunota).subscribe({
      next: (res: any) => {
        const body  = res?.responseBody ?? res;
        const det   = body?.detalhe ?? body;
        const itens: any[] = det?.itens ?? [];
        this.dividirItens = itens.map((it: any) => ({
          seq:          it.seq       ?? 0,
          codprod:      it.codprod   ?? 0,
          descricao:    it.descricao ?? '',
          refforn:      it.refforn   ?? '',
          condicao:     it.condicao  ?? '',
          qtdOriginal:  Number(it.qtd ?? 0),
          qtdParaMover: 0,
        }));
        this.dividirItensCarregando = false;
      },
      error: (err: any) => {
        this.dividirErro            = err?.error?.erro ?? err?.message ?? 'Erro ao carregar itens.';
        this.dividirItensCarregando = false;
      }
    });
  }

  fecharModalDividir(): void {
    if (this.dividirCarregando || this.dividirItensCarregando) return;
    this.modalDividirAberto = false;
  }

  onDividirQtdInput(_ev: Event, item: DividirItem): void {
    this.clampDividirQtd(item);
  }

  clampDividirQtd(item: DividirItem): void {
    let v = Math.floor(Number(item.qtdParaMover) || 0);
    if (v < 0) v = 0;
    if (v > item.qtdOriginal) v = item.qtdOriginal;
    item.qtdParaMover = v;
  }

  navegarDividirQtd(ev: Event): void {
    const inputs = Array.from(document.querySelectorAll<HTMLInputElement>('.div-qtd-input'));
    const idx    = inputs.indexOf(ev.target as HTMLInputElement);
    if (idx >= 0 && idx < inputs.length - 1) {
      inputs[idx + 1].focus();
      inputs[idx + 1].select();
    }
  }

  confirmarDividir(): void {
    if (this.origemFicariaSemItens || this.dividirItensNova.length === 0) return;
    this.dividirAvisoItensTotal = this.dividirItens.filter(
      i => i.qtdParaMover > 0 && i.qtdParaMover >= i.qtdOriginal
    );
    this.dividirAvisoAberto = true;
  }

  confirmarDividirComAviso(): void {
    this.dividirAvisoAberto = false;
    this._executarDividir();
  }

  private _executarDividir(): void {
    if (!this.dividirNunota) return;
    const itens = this.dividirItensNova.map(i => ({ seq: i.seq, qtd: i.qtdParaMover }));
    this.dividirCarregando = true;
    this.dividirErro       = '';
    this.gw.dividirPedidoVenda(this.dividirNunota, itens).subscribe({
      next: (res: any) => {
        this.dividirCarregando  = false;
        const body       = res?.responseBody ?? res;
        // O addon pode responder com HTTP 200 mesmo em falha (ex.: a venda
        // nova foi criada, mas a atualização da venda original — que remove
        // os itens movidos — deu erro nativo do Sankhya e sofreu rollback).
        // Nesse caso body.sucesso vem false com body.erro preenchido — sem
        // checar isso aqui, o modal fechava e mostrava "sucesso" mesmo
        // quando os itens continuavam duplicados nas duas vendas.
        if (body?.sucesso === false) {
          this.dividirErro = body?.erro ?? 'Erro ao desmembrar venda.';
          return;
        }
        this.modalDividirAberto = false;
        const novoNunota = body?.nunotaNova ?? body?.nunota;
        let msg = novoNunota ? `Venda desmembrada! Nova venda: #${novoNunota}` : 'Venda desmembrada com sucesso!';
        if (body?.avisoTgfvar) msg += ' ⚠ ' + body.avisoTgfvar;
        this.mostrarToast(msg);
        // Vai para a lista e seleciona a nova venda com o lastro (fluxo) aberto
        this.activeView.set(this._vLista());
        if (novoNunota) {
          setTimeout(() => this.listaAtiva?.focarPedido(Number(novoNunota), true), 400);
        } else {
          this.refreshLista();
        }
      },
      error: (err: any) => {
        this.dividirCarregando = false;
        this.dividirErro       = err?.error?.erro ?? err?.message ?? 'Erro ao desmembrar venda.';
      }
    });
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Modal Dados do Transporte
  // ══════════════════════════════════════════════════════════════════════════
  modalTransporteAberto          = false;
  transporteNunota: number | null = null;
  transporteNomeCliente          = '';
  transporteCarregando           = false;
  transporteSalvando             = false;
  transporteErro                 = '';

  // Endereço + Pessoa de entrega (somente leitura)
  transportePessoaEntregaDisplay  = '';
  transportePessoaEntregaDocparc  = '';
  transportePessoaEntregaIE       = '';
  transporteEndLogradouro         = '';
  transporteEndNumero             = '';
  transporteEndComplemento        = '';
  transporteEndBairro             = '';
  transporteEndCep                = '';
  transporteEndCidade             = '';
  transporteEndUf                 = '';

  // Títulos posicionados via canvas (igual ao pedido-venda). Aqui a fonte já
  // batia com o CSS real (.trp-end-input-field/.trp-pessoa-display-input são
  // 13px, igual ao TRP_FONT) -- diferente do bug do pedido-venda.component
  // (fonte de medição menor que a real). O que faltava era o border-left do
  // input (1.5px, box-sizing:border-box -- ver .trp-end-input-field no CSS):
  // o texto começa em border-left + padding-left a partir da borda externa
  // da caixa, não só no padding-left. 32px sozinho deixava os títulos ~1.5px
  // à esquerda do lugar certo.
  private readonly TRP_FONT        = '400 13px "Segoe UI", Roboto, Arial, sans-serif';
  private readonly TRP_TEXT_OFFSET = 33.5; // border-left (1.5px) + padding-left (32px) dos inputs do modal
  private _trpCanvasCtx:      CanvasRenderingContext2D | null = null;
  private _pessoaEntCanvasCtx: CanvasRenderingContext2D | null = null;
  // Rótulo "TRANSPORTADORA" (.dup-label dentro de .trp-titulos-linha) agora
  // começa no mesmo x que o texto do input (TRP_TEXT_OFFSET, via CSS), então
  // os títulos extras (CNPJ/CPF, INSC. ESTADUAL) -- que são posicionados a
  // partir da largura do "codparc - nome" -- precisam respeitar uma largura
  // mínima igual à do próprio rótulo, senão ficam embaixo dele quando o
  // "codparc - nome" é mais curto que "TRANSPORTADORA".
  private readonly TRP_LABEL_FONT = '700 11px "Segoe UI", Roboto, Arial, sans-serif';
  private _trpLabelCanvasCtx: CanvasRenderingContext2D | null = null;
  private _trpLarguraMinimaRotulo(texto: string): number {
    if (!this._trpLabelCanvasCtx) {
      const c = document.createElement('canvas');
      this._trpLabelCanvasCtx = c.getContext('2d');
    }
    const ctx = this._trpLabelCanvasCtx;
    if (!ctx) return 0;
    ctx.font = this.TRP_LABEL_FONT;
    return this.TRP_TEXT_OFFSET + ctx.measureText(texto.toUpperCase()).width + 14;
  }

  /** Ponto X (a partir da borda externa do input, em px) onde o TEXTO do
   *  input "Transportadora" deve começar. Igual ao padrão (33.5px) na
   *  maioria dos casos -- só aumenta (empurrando o padding-left do input
   *  junto, via [style.padding-left.px] no template) quando o "codparc -
   *  nome" selecionado é mais curto que o rótulo "TRANSPORTADORA", pra o
   *  1º título extra não ficar por baixo dele. Recalculado a cada seleção
   *  em _calcTitulosTransp -- NÃO é fixo, senão nomes longos (maioria)
   *  ficavam com um padding-left artificialmente grande. */
  trpBuscaInputStartX = this.TRP_TEXT_OFFSET;
  titulosTranspModal:    TrpTitulo[] = [];
  titulosPessoaEntModal: TrpTitulo[] = [];

  // Transportadora (autocomplete)
  transporteTranspBusca          = '';
  transporteTranspSelecionada: TranspSugestao | null = null;
  transporteTranspSugestoes: TranspSugestao[] = [];
  transporteMostrarDropdownTransp = false;
  transporteTranspCarregando     = false;
  private _transpNomeOriginal    = '';
  private _trpTitulosOriginais: TrpTitulo[] = [];
  private _transpTimer: ReturnType<typeof setTimeout> | null = null;

  // Campos editáveis
  transporteQtdVol     = 0;
  transportePesoBruto  = 0;
  transporteTipFrete   = '';
  transporteCifFob     = '';
  transporteFormaEnvio = '';
  trpVlrFrete: number | null = null;
  trpAdFreteObs        = '';

  transporteTipFreteOpcoes:   { valor: string; label: string }[] = [];
  transporteCifFobOpcoes:     { valor: string; label: string }[] = [];
  transporteFormaEnvioOpcoes: { valor: string; label: string }[] = [];

  // ── Impressão de etiqueta (botão "Imprimir") ────────────────
  // Pedido do usuário: imprimir os dados da venda+transporte (dados de
  // entrega/cliente entrega) direto numa das etiquetas já cadastradas em
  // Configuração de Etiquetas — mas só nas que ele liberou pra essa tela
  // em Parâmetros do Sistema → "Etiquetas disponíveis por tela"
  // (parâmetro ETIQUETAS_TELA_TRANSPORTE, CSV de CODCONFIG).
  etiquetasTransporteDisponiveis: { codconfig: number; nome: string }[] = [];
  private _etiquetasTransporteCarregadas = false;
  modalEscolherEtiquetaAberto = false;
  imprimindoTransporte        = false;
  transporteImprimirErro      = '';

  onSolicitarTransportePedido(nunota: number): void {
    this.transporteNunota             = nunota;
    this.transporteErro               = '';
    this.transporteNomeCliente        = '';
    this.transporteTranspBusca        = '';
    this.transporteTranspSelecionada  = null;
    this.transporteTranspSugestoes    = [];
    this.transporteMostrarDropdownTransp = false;
    this._transpNomeOriginal          = '';
    this.transporteQtdVol             = 0;
    this.transportePesoBruto          = 0;
    this.transporteTipFrete           = '';
    this.transporteCifFob             = '';
    this.transporteFormaEnvio         = '';
    this.trpVlrFrete                  = null;
    this.trpAdFreteObs                = '';
    this.transportePessoaEntregaDisplay = '';
    this.transportePessoaEntregaDocparc = '';
    this.transportePessoaEntregaIE      = '';
    this.titulosTranspModal             = [];
    this.titulosPessoaEntModal          = [];
    this.trpBuscaInputStartX            = this.TRP_TEXT_OFFSET;
    this.transporteEndLogradouro      = '';
    this.transporteEndNumero          = '';
    this.transporteEndComplemento     = '';
    this.transporteEndBairro          = '';
    this.transporteEndCep             = '';
    this.transporteEndCidade          = '';
    this.transporteEndUf              = '';
    this.modalEscolherEtiquetaAberto  = false;
    this.transporteImprimirErro       = '';
    this.modalTransporteAberto        = true;
    this._carregarOpcoesTransporte();
    this._carregarTransporte(nunota);
  }

  /** Mesma regra do modal completo de Pedido de Venda (ver vlrFreteBloqueado/
   *  onCifFobChange em pedido-venda.component.ts) — duplicada aqui porque
   *  esse modal "Dados do Transporte" (aberto pela lista de pedidos, ação
   *  "Dados do Transporte") é uma tela separada com seus próprios campos
   *  transporteCifFob/transporteTipFrete/trpVlrFrete, não reaproveita o
   *  componente de pedido-venda.
   *  Trava (bloqueia e zera) o Vlr. Frete quando: nada selecionado ainda
   *  ("— Selecione —"), FOB, Transp. Próprio Destinatário, Sem Ocorrência de
   *  Transporte, ou Transp. Próprio Remetente (correção pedida pelo
   *  usuário — só o CIF puro continua liberado). Casamos pelo TEXTO da
   *  opção (não um valor fixo) porque o combo nativo TIPFRETE/CIF_FOB varia
   *  por instalação do Sankhya. */
  private static readonly TRP_CIFFOB_KEYWORDS_BLOQUEIA = ['FOB', 'DESTINAT', 'SEM OCORR', 'SEM FRETE'];

  get transporteVlrFreteBloqueado(): boolean {
    if (!this.transporteCifFob) return true;
    const label = (this.transporteCifFobOpcoes.find(o => o.valor === this.transporteCifFob)?.label ?? '').toUpperCase();
    if (!label) return true;
    if (GatewayComponent.TRP_CIFFOB_KEYWORDS_BLOQUEIA.some(k => label.includes(k))) return true;
    const ehProprio = label.includes('PRÓPRIO') || label.includes('PROPRIO');
    const ehRemetente = label.includes('REMETENTE');
    return ehProprio && ehRemetente;
  }

  /** Ao trocar CIF/FOB: zera o Vlr. Frete se a nova modalidade travar, e
   *  ajusta o Tipo do Frete pro mesmo agrupamento (liberado → "Incluso",
   *  bloqueado → "Extra Nota" — só evita deixar o campo em branco, já que o
   *  valor fica sempre zero quando bloqueado). */
  onTransporteCifFobChange(): void {
    if (this.transporteVlrFreteBloqueado) {
      this.trpVlrFrete = 0;
    }
    // CIF/FOB voltou pro "— Selecione —" (vazio) — Tipo do Frete acompanha
    // e também volta pro "Selecione", em vez de cair em "Extra Nota".
    if (!this.transporteCifFob) {
      this.transporteTipFrete = '';
      return;
    }
    const alvo = this.transporteVlrFreteBloqueado ? 'EXTRA' : 'INCLUS';
    const opcaoTipFrete = this.transporteTipFreteOpcoes.find(o => o.label.toUpperCase().includes(alvo));
    if (opcaoTipFrete) this.transporteTipFrete = opcaoTipFrete.valor;
  }

  private _carregarOpcoesTransporte(): void {
    const parse = (res: any): { valor: string; label: string }[] => {
      const body = res?.responseBody ?? res;
      return (body?.opcoes ?? []).map((o: any) =>
        typeof o === 'string'
          ? { valor: o,         label: o }
          : { valor: o.valor ?? o, label: o.opcao ?? o.valor ?? o }
      );
    };
    this.gw.buscarOpcoesCampoPedidoVenda('TGFCAB', 'TIPFRETE').subscribe({
      next: (res: any) => { this.transporteTipFreteOpcoes   = parse(res); },
      error: () => {}
    });
    this.gw.buscarOpcoesCampoPedidoVenda('TGFCAB', 'CIF_FOB').subscribe({
      next: (res: any) => { this.transporteCifFobOpcoes     = parse(res); },
      error: () => {}
    });
    this.gw.buscarOpcoesCampoPedidoVenda('TGFCAB', 'GPL_FORMAENVIO').subscribe({
      next: (res: any) => { this.transporteFormaEnvioOpcoes = parse(res); },
      error: () => {}
    });
  }

  private _carregarTransporte(nunota: number): void {
    this.transporteCarregando = true;
    this.gw.buscarDetalhesPedidoVenda(nunota).subscribe({
      next: (res: any) => {
        const body = res?.responseBody ?? res;
        const det  = body?.detalhe ?? body;

        this.transporteNomeCliente    = det?.cliente     ?? '';
        this.transporteQtdVol         = Number(det?.qtdVol    ?? 0);
        this.transportePesoBruto      = Number(det?.pesoBruto ?? 0);
        this.transporteTipFrete       = det?.tipFrete    ?? '';
        this.transporteCifFob         = det?.cifFob      ?? '';
        this.transporteFormaEnvio     = det?.formaEnvio  ?? '';
        // CIF/FOB nunca foi escolhido pra este pedido — TIPFRETE que veio do
        // Sankhya nesse caso é só o default nativo do campo (TGFCAB), não
        // uma escolha real do vendedor. Não mostra "Incluso"/"Extra Nota"
        // como se fosse — mesma regra do onTransporteCifFobChange (pedido
        // do usuário: "quando não tem nenhum [CIF/FOB] gravado ainda").
        if (!this.transporteCifFob) {
          this.transporteTipFrete = '';
        }
        this.trpVlrFrete              = Number(det?.vlrFrete  ?? 0) || null;
        this.trpAdFreteObs            = det?.adFreteObs  ?? '';

        this.transporteEndLogradouro  = det?.endLogradouro  ?? '';
        this.transporteEndNumero      = det?.endNumero       ?? '';
        this.transporteEndComplemento = det?.endComplemento ?? '';
        this.transporteEndBairro      = det?.endBairro      ?? '';
        this.transporteEndCep         = det?.endCep         ?? '';
        this.transporteEndCidade      = det?.endCidade      ?? '';
        this.transporteEndUf          = det?.endUf          ?? '';

        const codTransp    = Number(det?.codParcTransp ?? 0);
        if (codTransp > 0) {
          this._buscarTransportadoraPorCodigo(codTransp);
        }
        const codParcDest  = Number(det?.codParcDest ?? 0);
        if (codParcDest > 0) {
          this._buscarPessoaEntregaPorCodigo(codParcDest);
        }
        this.transporteCarregando = false;
      },
      error: (err: any) => {
        this.transporteErro       = err?.error?.erro ?? err?.message ?? 'Erro ao carregar dados.';
        this.transporteCarregando = false;
      }
    });
  }

  /** Lista as etiquetas cadastradas em Configuração de Etiquetas e filtra
   *  pelas liberadas pra essa tela em Parâmetros do Sistema
   *  (ETIQUETAS_TELA_TRANSPORTE, CSV de CODCONFIG). Se o parâmetro não
   *  existir/estiver vazio, considera que nenhuma etiqueta foi liberada —
   *  não mostra "todas" por padrão (evita imprimir numa etiqueta que não
   *  faz sentido nessa tela). */
  private async _carregarEtiquetasDisponiveisTransporte(): Promise<void> {
    try {
      const [resConfigs, resParam] = await Promise.all([
        firstValueFrom(this.gw.listarEtiquetaConfigs()),
        firstValueFrom(this.gw.buscarValoresParametros(['ETIQUETAS_TELA_TRANSPORTE']))
      ]);
      const bodyConfigs: any = (resConfigs as any)?.responseBody ?? resConfigs;
      const bodyParam: any   = (resParam as any)?.responseBody ?? resParam;

      const csv = bodyParam?.valores?.ETIQUETAS_TELA_TRANSPORTE ?? '';
      const liberados = new Set(
        String(csv).split(',').map((v: string) => Number(v.trim())).filter((v: number) => Number.isFinite(v) && v > 0)
      );

      const todas: { codconfig: number; nome: string }[] = (bodyConfigs?.lista ?? []).map((c: any) => ({
        codconfig: Number(c.codconfig),
        nome:      c.nome
      }));

      this.etiquetasTransporteDisponiveis = todas.filter(e => liberados.has(e.codconfig));
    } catch {
      this.etiquetasTransporteDisponiveis = [];
    } finally {
      this._etiquetasTransporteCarregadas = true;
    }
  }

  /** Botão "Imprimir" do modal Dados do Transporte. Se só houver uma
   *  etiqueta liberada pra essa tela, imprime direto; se houver mais de
   *  uma, abre um seletor rápido (pedido do usuário: "escolher na hora"). */
  async imprimirDadosTransporte(): Promise<void> {
    if (!this.transporteNunota || this.imprimindoTransporte) return;
    this.transporteImprimirErro = '';

    if (!this._etiquetasTransporteCarregadas) {
      await this._carregarEtiquetasDisponiveisTransporte();
    }

    if (this.etiquetasTransporteDisponiveis.length === 0) {
      this.transporteImprimirErro =
        'Nenhuma etiqueta liberada para esta tela. Configure em Parâmetros do Sistema → "Etiquetas disponíveis por tela".';
      return;
    }

    if (this.etiquetasTransporteDisponiveis.length === 1) {
      await this._imprimirEtiquetaTransporte(this.etiquetasTransporteDisponiveis[0].codconfig);
      return;
    }

    this.modalEscolherEtiquetaAberto = true;
  }

  fecharEscolherEtiqueta(): void {
    this.modalEscolherEtiquetaAberto = false;
  }

  async escolherEtiquetaTransporte(codconfig: number): Promise<void> {
    await this._imprimirEtiquetaTransporte(codconfig);
  }

  /** Busca a config da etiqueta escolhida + os dados reais da venda/entrega
   *  (via EtiquetaGlobalSP.doBuscarDadosImpressao, com NUNOTA — a mesma
   *  rota usada no "Testar com dados reais" da tela de Configuração de
   *  Etiquetas, que já resolve TGFPAR/TSIEND priorizando o
   *  CODPARCDEST/pessoa de entrega) e imprime via EtiquetaPrintService. */
  private async _imprimirEtiquetaTransporte(codconfig: number): Promise<void> {
    if (!this.transporteNunota) return;
    const nunota = this.transporteNunota; // fixa o valor pro TS não reclamar de null após os awaits abaixo
    this.imprimindoTransporte = true;
    this.transporteImprimirErro = '';
    try {
      // codEmpReal (não .selecionada) — se o usuário estiver numa empresa
      // VIRTUAL (Curitiba/BH/Rio Verde), CODEMP precisa ser o CODEMP nativo
      // de verdade (TSIEMP) por trás dela pra bater com V_ENDERECOEMP.
      const codemp = Number(this.empresaState.codEmpReal || '1');

      const [resConfig, resDados] = await Promise.all([
        firstValueFrom(this.gw.buscarEtiquetaConfig(codconfig)),
        firstValueFrom(this.gw.buscarDadosImpressaoEtiqueta(codconfig, codemp, nunota))
      ]);

      const bodyConfig: any = (resConfig as any)?.responseBody ?? resConfig;
      const cfg = bodyConfig?.config;
      if (!cfg) throw new Error('Configuração de etiqueta não encontrada.');

      let dados: EtiquetaDados;
      try {
        const parsed = JSON.parse(cfg.dadosJson || '{}');
        dados = parsed?.linhas ? parsed : {
          logo: { mostrar: false, alinhamento: 'esquerda', larguraPct: 20, alturaMm: 0, margemTopMm: 0, margemBottomMm: 2 },
          margens: { superior: 1, inferior: 1, esquerda: 1, direita: 1 },
          linhas: []
        };
      } catch {
        throw new Error('Configuração de etiqueta inválida.');
      }

      const bodyDados: any = (resDados as any)?.responseBody ?? resDados;
      if (!bodyDados?.sucesso) throw new Error(bodyDados?.erro ?? 'Erro ao carregar dados de impressão.');

      const dadosReais: Record<string, Record<string, string>> = {};
      for (const fonte of Object.keys(bodyDados.dados ?? {})) {
        dadosReais[fonte.toUpperCase()] = {};
        for (const col of Object.keys(bodyDados.dados[fonte])) {
          dadosReais[fonte.toUpperCase()][col.toUpperCase()] = bodyDados.dados[fonte][col];
        }
      }

      // TGFPAR não tem colunas nativas NOMEEND/NOMEBAI/NOMECID/UF (só as
      // chaves CODEND/CODBAI/CODCID) — uma etiqueta com campo "TGFPAR.NOMEEND"
      // (comum: o editor de etiquetas oferece essa coluna no seletor mesmo
      // sem existir de verdade) sai em branco se depender só do que o
      // addon devolveu. Mas esse endereço de entrega a gente JÁ tem aqui,
      // carregado certinho pelo próprio modal de Dados do Transporte
      // (mesmos campos mostrados em tela) — usa direto, sem round-trip
      // extra nem depender do addon resolver de novo.
      const tgfpar = dadosReais['TGFPAR'] ??= {};
      if (!tgfpar['NOMEEND'] && this.transporteEndLogradouro) tgfpar['NOMEEND'] = this.transporteEndLogradouro;
      if (!tgfpar['NOMEBAI'] && this.transporteEndBairro) tgfpar['NOMEBAI'] = this.transporteEndBairro;
      if (!tgfpar['NOMECID'] && this.transporteEndCidade) tgfpar['NOMECID'] = this.transporteEndCidade;
      if (!tgfpar['UF'] && this.transporteEndUf) tgfpar['UF'] = this.transporteEndUf;
      if (!tgfpar['CEP'] && this.transporteEndCep) tgfpar['CEP'] = this.transporteEndCep;
      if (!tgfpar['NUMEND'] && this.transporteEndNumero) tgfpar['NUMEND'] = this.transporteEndNumero;
      if (!tgfpar['COMPLEMENTO'] && this.transporteEndComplemento) tgfpar['COMPLEMENTO'] = this.transporteEndComplemento;
      const ufEndereco = this.transporteEndUf || tgfpar['UF'] || '';
      const cidadeEndereco = this.transporteEndCidade || tgfpar['NOMECID'] || '';
      if (!tgfpar['UF_CIDADE'] && (ufEndereco || cidadeEndereco)) {
        tgfpar['UF_CIDADE'] = [ufEndereco, cidadeEndereco].filter(Boolean).join(' - ');
      }
      if (!tgfpar['CIDADE_UF'] && (ufEndereco || cidadeEndereco)) {
        tgfpar['CIDADE_UF'] = [cidadeEndereco, ufEndereco].filter(Boolean).join(' - ');
      }

      const contexto: EtiquetaImpressaoContexto = {
        nome: cfg.nome,
        largura: Number(cfg.larguraMm),
        altura: Number(cfg.alturaMm),
        dados,
        dadosReais,
        logoVisivelImpressao: dados.logo?.mostrar ?? false
      };

      const impressoraSelecionada = this.printSvc.impressoraSalva;
      const modoImpressaoLocal    = this.printSvc.modoImpressaoSalvo;

      if (impressoraSelecionada) {
        try {
          const impressoras = await this.printSvc.listarImpressoras();
          const impressora  = impressoras.find(p => p.nome === impressoraSelecionada) ?? null;
          await this.printSvc.imprimirViaQz(contexto, impressoraSelecionada, modoImpressaoLocal, impressora);
          this.modalEscolherEtiquetaAberto = false;
          return;
        } catch {
          // Impressora local falhou (QZ Tray fechado, impressora offline etc.)
          // — cai pro diálogo de impressão do navegador, igual à tela de
          // Configuração de Etiquetas.
        }
      }
      await this.printSvc.imprimirNoNavegador(contexto);
      this.modalEscolherEtiquetaAberto = false;
    } catch (e: any) {
      this.transporteImprimirErro = e?.message ?? 'Não foi possível imprimir a etiqueta.';
    } finally {
      this.imprimindoTransporte = false;
    }
  }

  // ── Formatadores de documento ─────────────────────────────────────────────

  fmtDocumento(doc: string | null | undefined): string {
    const d = (doc ?? '').replace(/\D/g, '');
    if (d.length === 14) return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    if (d.length === 11) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    return doc || '';
  }

  fmtIE(ie: string | null | undefined): string {
    const d = (ie ?? '').replace(/\D/g, '');
    if (d.length === 12) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{3})$/, '$1.$2.$3.$4');
    if (d.length === 10) return d.replace(/^(\d{3})(\d{5})(\d{2})$/, '$1.$2-$3');   // PR
    if (d.length === 9)  return d.replace(/^(\d{3})(\d{3})(\d{3})$/, '$1.$2.$3');
    if (d.length === 8)  return d.replace(/^(\d{2})(\d{3})(\d{2})(\d{1})$/, '$1.$2.$3-$4');
    return ie || '';
  }

  // ── helpers canvas (posicionamento de títulos inline no input) ──────────────

  private _formatarParcTexto(codparc: number, nome: string, doc: string, ie: string): string {
    const partes = [
      doc ? this.fmtDocumento(doc) : null,
      ie  ? this.fmtIE(ie)         : null,
    ].filter(v => !!v && String(v).trim().length > 0) as string[];
    const base = `${codparc} - ${nome}`;
    return partes.length > 0 ? `${base}   |   ${partes.join('   |   ')}` : base;
  }

  private _calcTitulosTransp(codparc: number, nome: string, doc: string, ie: string): void {
    if (!this._trpCanvasCtx) {
      const c = document.createElement('canvas');
      this._trpCanvasCtx = c.getContext('2d');
    }
    const ctx = this._trpCanvasCtx;
    if (!ctx) { this.titulosTranspModal = []; return; }
    ctx.font = this.TRP_FONT;
    const larguraNome = ctx.measureText(`${codparc} - ${nome}`).width;
    this.trpBuscaInputStartX = Math.max(this.TRP_TEXT_OFFSET, this._trpLarguraMinimaRotulo('Transportadora') - larguraNome);
    let offset = this.trpBuscaInputStartX + larguraNome;
    const campos = [
      { label: 'CNPJ/CPF', valor: doc, display: this.fmtDocumento(doc) },
      { label: 'INSC. ESTADUAL', valor: ie, display: this.fmtIE(ie) },
    ];
    const titulos: TrpTitulo[] = [];
    for (const campo of campos) {
      if (!campo.valor || !String(campo.valor).trim()) continue;
      offset += ctx.measureText('   |   ').width;
      titulos.push({ label: campo.label, left: offset });
      offset += ctx.measureText(campo.display || campo.valor).width;
    }
    this.titulosTranspModal = titulos;
  }

  private _calcTitulosPessoaEnt(codparc: number, nome: string, doc: string, ie: string): void {
    if (!this._pessoaEntCanvasCtx) {
      const c = document.createElement('canvas');
      this._pessoaEntCanvasCtx = c.getContext('2d');
    }
    const ctx = this._pessoaEntCanvasCtx;
    if (!ctx) { this.titulosPessoaEntModal = []; return; }
    ctx.font = this.TRP_FONT;
    let offset = this.TRP_TEXT_OFFSET + ctx.measureText(`${codparc} - ${nome}`).width;
    const campos = [
      { label: 'CNPJ/CPF', valor: doc, display: this.fmtDocumento(doc) },
      { label: 'INSC. ESTADUAL', valor: ie, display: this.fmtIE(ie) },
    ];
    const titulos: TrpTitulo[] = [];
    for (const campo of campos) {
      if (!campo.valor || !String(campo.valor).trim()) continue;
      offset += ctx.measureText('   |   ').width;
      titulos.push({ label: campo.label, left: offset });
      offset += ctx.measureText(campo.display || campo.valor).width;
    }
    this.titulosPessoaEntModal = titulos;
  }

  // ── buscar por código ─────────────────────────────────────────────────────

  private _buscarTransportadoraPorCodigo(cod: number): void {
    this.transporteTranspCarregando = true;
    this.gw.buscarClientePedidoVenda(String(cod)).subscribe({
      next: (res: any) => {
        const body  = res?.responseBody ?? res;
        const lista: any[] = body?.lista ?? [];
        const found = lista.find((p: any) => Number(p.codparc) === cod);
        if (found) {
          const s: TranspSugestao = {
            codparc:      cod,
            nomeparc:     found.nomeparc     ?? '',
            docparc:      found.docparc      ?? '',
            inscEstadual: found.inscEstadual ?? '',
          };
          this.transporteTranspSelecionada = s;
          const txt = this._formatarParcTexto(s.codparc, s.nomeparc, s.docparc ?? '', s.inscEstadual ?? '');
          this.transporteTranspBusca   = txt;
          this._transpNomeOriginal     = txt;
          this._calcTitulosTransp(s.codparc, s.nomeparc, s.docparc ?? '', s.inscEstadual ?? '');
        }
        this.transporteTranspCarregando = false;
      },
      error: () => { this.transporteTranspCarregando = false; }
    });
  }

  private _buscarPessoaEntregaPorCodigo(cod: number): void {
    this.gw.buscarClientePedidoVenda(String(cod)).subscribe({
      next: (res: any) => {
        const body  = res?.responseBody ?? res;
        const lista: any[] = body?.lista ?? [];
        const found = lista.find((p: any) => Number(p.codparc) === cod);
        if (found) {
          const nome = found.nomeparc     ?? '';
          const doc  = found.docparc      ?? '';
          const ie   = found.inscEstadual ?? '';
          this.transportePessoaEntregaDocparc = doc;
          this.transportePessoaEntregaIE      = ie;
          this.transportePessoaEntregaDisplay = this._formatarParcTexto(cod, nome, doc, ie);
          this._calcTitulosPessoaEnt(cod, nome, doc, ie);
        } else {
          this.transportePessoaEntregaDisplay = '';
        }
      },
      error: () => { this.transportePessoaEntregaDisplay = ''; }
    });
  }

  fecharModalTransporte(): void {
    if (this.transporteSalvando) return;
    this.modalTransporteAberto = false;
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Status — Autorizar
  // ══════════════════════════════════════════════════════════════════════════
  autorizandoPedido: number | null = null;

  /** Pré-Venda autorizada: confirma a nota no Sankhya e abre "Gerar Venda" (itens/quantidades). */
  private confirmarPreVendaEAbrirGeracao(nunota: number): void {
    this.mostrarToast(`Confirmando Pré-Venda #${nunota}...`, 15000);
    this.gw.confirmarPreVenda(nunota).subscribe({
      next: (r: any) => {
        if (r?.sucesso === false) {
          this.mostrarToast(`Pré-Venda #${nunota} autorizada, mas não foi confirmada: ${r?.erro ?? ''}`, 14000);
          setTimeout(() => this.listaAtiva?.buscar(), 300);
          return;
        }
        this.mostrarToast(`Pré-Venda #${nunota} autorizada e confirmada. Escolha os itens para gerar a Venda.`, 7000);
        setTimeout(() => { this.listaAtiva?.buscar(false); this.preVendaListaRef?.abrirGerarVenda(nunota); }, 300);
      },
      error: (err: any) => {
        this.mostrarToast(`Pré-Venda #${nunota} autorizada, mas a confirmação falhou: ${err?.error?.erro ?? err?.message ?? 'erro de comunicação'}`, 14000);
        setTimeout(() => this.listaAtiva?.buscar(), 300);
      }
    });
  }

  onSolicitarAutorizarPedido(nunota: number): void {
    if (this.modoPreVenda()) {
      // Pré-Venda: primeiro escolhe os itens/quantidades da Venda (modal); a autorização valida as liberações ao confirmar.
      this.preVendaListaRef?.abrirAutorizar(nunota);
      return;
    }

    if (this.autorizandoPedido === nunota) return; // evitar duplo clique
    this.autorizandoPedido = nunota;
    this.mostrarToast(`Autorizando orçamento #${nunota}...`, 20000);

    this.gw.autorizarPedidoVenda(nunota).subscribe({
      next: (res: any) => {
        this.autorizandoPedido = null;
        const body = res?.responseBody ?? res;
        if (body?.sucesso === true || body?.sucesso === 'true') {
          const pendente = body.pendente === true || body.pendente === 'true'
                        || body.statusNota === 'PENDENTE';
          if (pendente) {
            const motivo = body.motivoPendente ?? body.mensagem ?? 'Aguardando aprovação do gestor.';
            this.mostrarToast(
              `⏳ Orçamento #${nunota} aguardando aprovação do gestor.\n${motivo}`,
              15000
            );
          } else if (this.modoPreVenda()) {
            // Pré-Venda (TOP 1000): confirma a nota (sem trocar a TOP) e abre a seleção de itens para gerar a Venda.
            this.confirmarPreVendaEAbrirGeracao(nunota);
          } else if (Number(body.codTipOper) === 1152) {
            // Venda de Transferência (TOP 1152, AD_CATEGORIA=TRANSFERENCIA) — já
            // nasce na TOP final, não precisa trocar (nem faz sentido converter
            // 1152→1001). Pula direto pra atribuir seriais/lotes e confirmar,
            // mesma continuação de converterOrcamentoEmPedidoNativo depois da troca.
            this.atribuirControlesAutomaticos(nunota);
          } else {
            // Autorizado no GPL (GPL_STATUS='AUTORIZADO') → agora troca a TOP de
            // verdade (1000→1001) via motor nativo do Sankhya, antes de atribuir
            // seriais/lotes e confirmar.
            this.converterOrcamentoEmPedidoNativo(nunota);
          }
          setTimeout(() => this.listaAtiva?.buscar(), 300);
        } else {
          // sucesso=false pode ser "ainda ha liberacoes pendentes" — tratar diferente de erro
          const isPendente = body?.pendente === true || body?.pendente === 'true';
          const msg = body?.erro ?? 'Erro desconhecido ao autorizar.';
          if (isPendente) {
            this.mostrarToast(`⏳ ${msg}`, 12000);
          } else {
            this.mostrarToast(`Erro ao autorizar #${nunota}: ${msg}`, 10000);
          }
        }
      },
      error: (err: any) => {
        this.autorizandoPedido = null;
        const msg = err?.error?.erro ?? err?.message ?? 'Erro de comunicação.';
        this.mostrarToast(`Erro ao autorizar #${nunota}: ${msg}`, 10000);
      }
    });
  }

  // ── Anexos de documentos por venda (GPL_ANEXO_VENDA) ─────────────────────
  // Mecanismo PRÓPRIO do addon (BLOB numa tabela nossa) — independente do
  // "clipe" nativo do Sankhya (incompatível com Cabeçalho de Nota) e
  // independente de qualquer tela nativa, já que esta tela é externa/custom.
  anexosModalAberto = false;
  anexosNunota: number | null = null;
  anexosLista: any[] = [];
  anexosCarregando = false;
  anexoEnviando = false;

  // Pré-visualização (imagens e PDF direto na tela; outros tipos caem pro download)
  previewModalAberto = false;
  previewUrl: SafeResourceUrl | null = null;
  previewTipo: 'imagem' | 'pdf' | null = null;
  previewNome = '';
  private _previewObjectUrl: string | null = null; // URL "crua" — precisa pra revokeObjectURL
  private readonly EXTENSOES_IMAGEM = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];

  visualizarAnexoVenda(anexo: any): void {
    const ext = (anexo.extensao || '').toLowerCase();
    const ehImagem = this.EXTENSOES_IMAGEM.includes(ext);
    const ehPdf = ext === 'pdf';

    if (!ehImagem && !ehPdf) {
      this.mostrarToast('Pré-visualização não disponível para este tipo de arquivo — baixando...', 5000);
      this.baixarAnexoVenda(anexo);
      return;
    }

    this.gw.baixarAnexoVenda(anexo.nuanexo).subscribe({
      next: (res: any) => {
        const body = res?.responseBody ?? res;
        if (!body?.conteudoBase64) {
          this.mostrarToast('Erro ao carregar pré-visualização.', 8000);
          return;
        }
        const byteChars = atob(body.conteudoBase64);
        const byteNumbers = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);
        const byteArray = new Uint8Array(byteNumbers);
        const mime = ehPdf ? 'application/pdf' : `image/${ext === 'jpg' ? 'jpeg' : ext}`;
        const blob = new Blob([byteArray], {type: mime});

        if (this._previewObjectUrl) window.URL.revokeObjectURL(this._previewObjectUrl);
        this._previewObjectUrl = window.URL.createObjectURL(blob);
        // iframe/img [src] passam pelo DomSanitizer do Angular — um blob: cru é
        // bloqueado silenciosamente (principalmente em contexto de resourceUrl,
        // usado pelo iframe do PDF), por isso sempre passamos pelo bypass aqui.
        this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this._previewObjectUrl);
        this.previewTipo = ehPdf ? 'pdf' : 'imagem';
        this.previewNome = body.nomeArquivo ?? anexo.nomeArquivo ?? '';
        this.previewModalAberto = true;
      },
      error: () => this.mostrarToast('Erro ao carregar pré-visualização.', 8000)
    });
  }

  fecharPreviewAnexo(): void {
    if (this._previewObjectUrl) window.URL.revokeObjectURL(this._previewObjectUrl);
    this._previewObjectUrl = null;
    this.previewUrl = null;
    this.previewTipo = null;
    this.previewModalAberto = false;
  }

  onSolicitarAnexos(nunota: number): void {
    this.anexosNunota = nunota;
    this.anexosModalAberto = true;
    this.carregarAnexosVenda(nunota);
  }

  fecharModalAnexos(): void {
    this.anexosModalAberto = false;
    this.anexosNunota = null;
    this.anexosLista = [];
    this.fecharPreviewAnexo();
  }

  carregarAnexosVenda(nunota: number): void {
    this.anexosCarregando = true;
    this.gw.listarAnexosVenda(nunota).subscribe({
      next: (res: any) => {
        this.anexosCarregando = false;
        const body = res?.responseBody ?? res;
        this.anexosLista = body?.lista ?? [];
      },
      error: () => {
        this.anexosCarregando = false;
        this.mostrarToast('Erro ao carregar anexos da venda.', 8000);
      }
    });
  }

  onSelecionarArquivosAnexo(event: Event): void {
    const input = event.target as HTMLInputElement;
    const arquivos = input.files;
    const nunota = this.anexosNunota;
    if (!arquivos || arquivos.length === 0 || !nunota) return;

    Array.from(arquivos).forEach(arquivo => this._enviarAnexo(nunota, arquivo));
    input.value = ''; // permite re-selecionar o mesmo arquivo depois
  }

  private _enviarAnexo(nunota: number, arquivo: File): void {
    const MAX_BYTES = 20 * 1024 * 1024; // 20MB — mesmo limite validado no addon
    if (arquivo.size > MAX_BYTES) {
      this.mostrarToast(`⚠️ "${arquivo.name}" excede 20MB e não foi enviado.`, 8000);
      return;
    }

    this.anexoEnviando = true;
    const reader = new FileReader();
    reader.onload = () => {
      const resultado = reader.result as string;
      // resultado vem como "data:<mime>;base64,AAAA..." — só a parte base64 interessa
      const conteudoBase64 = resultado.split(',')[1] ?? '';

      this.gw.anexarArquivoVenda(nunota, arquivo.name, conteudoBase64).subscribe({
        next: (res: any) => {
          this.anexoEnviando = false;
          const body = res?.responseBody ?? res;
          if (body?.sucesso === true || body?.sucesso === 'true') {
            this.mostrarToast(`📎 "${arquivo.name}" anexado.`, 5000);
            this.carregarAnexosVenda(nunota);
          } else {
            this.mostrarToast(`Erro ao anexar "${arquivo.name}": ${body?.erro ?? 'erro desconhecido'}.`, 8000);
          }
        },
        error: (err: any) => {
          this.anexoEnviando = false;
          const msg = err?.error?.erro ?? err?.message ?? 'Erro de comunicação.';
          this.mostrarToast(`Erro ao anexar "${arquivo.name}": ${msg}`, 8000);
        }
      });
    };
    reader.onerror = () => {
      this.anexoEnviando = false;
      this.mostrarToast(`Erro ao ler "${arquivo.name}".`, 8000);
    };
    reader.readAsDataURL(arquivo);
  }

  baixarAnexoVenda(anexo: any): void {
    this.gw.baixarAnexoVenda(anexo.nuanexo).subscribe({
      next: (res: any) => {
        const body = res?.responseBody ?? res;
        if (!body?.conteudoBase64) {
          this.mostrarToast('Erro ao baixar anexo.', 8000);
          return;
        }
        const byteChars = atob(body.conteudoBase64);
        const byteNumbers = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = body.nomeArquivo ?? anexo.nomeArquivo ?? 'anexo';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: () => this.mostrarToast('Erro ao baixar anexo.', 8000)
    });
  }

  excluirAnexoVenda(anexo: any): void {
    if (!confirm(`Excluir o anexo "${anexo.nomeArquivo}"?`)) return;
    this.gw.excluirAnexoVenda(anexo.nuanexo).subscribe({
      next: (res: any) => {
        const body = res?.responseBody ?? res;
        if (body?.sucesso === true || body?.sucesso === 'true') {
          this.mostrarToast('Anexo excluído.', 4000);
          this.anexosLista = this.anexosLista.filter((a: any) => a.nuanexo !== anexo.nuanexo);
        } else {
          this.mostrarToast(`Erro ao excluir anexo: ${body?.erro ?? 'erro desconhecido'}.`, 8000);
        }
      },
      error: () => this.mostrarToast('Erro ao excluir anexo.', 8000)
    });
  }

  formatarTamanhoAnexo(bytes: number): string {
    if (!bytes || bytes <= 0) return '—';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  onTransporteTranspFocus(): void {
    this._transpNomeOriginal  = this.transporteTranspBusca;
    this._trpTitulosOriginais = [...this.titulosTranspModal];
    if (this.transporteTranspSelecionada) {
      this.transporteTranspBusca = '';
      this.titulosTranspModal    = [];
      this.trpBuscaInputStartX   = this.TRP_TEXT_OFFSET;
    }
    this.transporteMostrarDropdownTransp = true;
    this._buscarTransportadoras(this.transporteTranspBusca);
  }

  onTransporteTranspInput(): void {
    this.transporteTranspSelecionada = null;
    this.titulosTranspModal          = [];
    this.trpBuscaInputStartX         = this.TRP_TEXT_OFFSET;
    this._buscarTransportadoras(this.transporteTranspBusca);
  }

  onTransporteTranspBlur(): void {
    setTimeout(() => {
      this.transporteMostrarDropdownTransp = false;
      if (!this.transporteTranspSelecionada || this.transporteTranspBusca === '') {
        if (this.transporteTranspBusca.trim() !== '' && this.transporteTranspSugestoes.length > 0 && !this.transporteTranspSelecionada) {
          // Auto-seleciona o primeiro resultado ao sair sem clicar
          this.selecionarTransporteTransp(this.transporteTranspSugestoes[0]);
        } else {
          // Restaura transportadora original
          this.transporteTranspBusca = this._transpNomeOriginal;
          this.titulosTranspModal    = [...this._trpTitulosOriginais];
        }
      }
    }, 200);
  }

  private _buscarTransportadoras(termo: string): void {
    if (this._transpTimer) clearTimeout(this._transpTimer);
    this._transpTimer = setTimeout(() => {
      if (!termo || termo.length < 2) {
        this.transporteTranspSugestoes = [];
        return;
      }
      this.transporteTranspCarregando = true;
      this.gw.buscarTransportadoraPedidoVenda(termo).subscribe({
        next: (res: any) => {
          const body  = res?.responseBody ?? res;
          const lista: any[] = body?.lista ?? [];
          this.transporteTranspSugestoes = lista.map((p: any) => ({
            codparc:      Number(p.codparc      ?? 0),
            nomeparc:     p.nomeparc     ?? '',
            docparc:      p.docparc      ?? '',
            inscEstadual: p.inscEstadual ?? '',
          }));
          this.transporteTranspCarregando = false;
        },
        error: () => { this.transporteTranspCarregando = false; }
      });
    }, 300);
  }

  selecionarTransporteTransp(s: TranspSugestao): void {
    this.transporteTranspSelecionada     = s;
    const txt = this._formatarParcTexto(s.codparc, s.nomeparc, s.docparc ?? '', s.inscEstadual ?? '');
    this.transporteTranspBusca           = txt;
    this._transpNomeOriginal             = txt;
    this.transporteMostrarDropdownTransp = false;
    this._calcTitulosTransp(s.codparc, s.nomeparc, s.docparc ?? '', s.inscEstadual ?? '');
  }

  removerTransporteTransp(): void {
    this.transporteTranspSelecionada = null;
    this.transporteTranspBusca       = '';
    this._transpNomeOriginal         = '';
    this.titulosTranspModal          = [];
    this.trpBuscaInputStartX         = this.TRP_TEXT_OFFSET;
  }

  confirmarTransporte(): void {
    if (!this.transporteNunota) return;

    // Trava de Vlr. Frete por modalidade CIF/FOB (ver transporteVlrFreteBloqueado)
    // — o campo já vem desabilitado na tela pra essas modalidades, mas essa
    // checagem aqui é o que de fato impede salvar caso o valor tenha vindo
    // de outro jeito (dado carregado antes de trocar a modalidade etc.).
    if (this.transporteVlrFreteBloqueado && (this.trpVlrFrete || 0) > 0) {
      this.transporteErro =
        'Para fretes do tipo FOB ou por conta do destinatário, o valor do frete deve ser zero. O transporte será pago pelo cliente diretamente à transportadora.';
      return;
    }

    this.transporteSalvando = true;
    this.transporteErro     = '';
    const dados: Record<string, unknown> = {
      codParcTransp: this.transporteTranspSelecionada?.codparc ?? null,
      qtdVol:        this.transporteQtdVol,
      pesoBruto:     this.transportePesoBruto,
      tipFrete:      this.transporteTipFrete   || null,
      cifFob:        this.transporteCifFob     || null,
      formaEnvio:    this.transporteFormaEnvio || null,
      vlrFrete:      this.trpVlrFrete ?? 0,
    };
    this.gw.atualizarDadosTransporte(this.transporteNunota, dados).subscribe({
      next: () => {
        this.transporteSalvando    = false;
        this.modalTransporteAberto = false;
        this.mostrarToast('Dados de transporte salvos com sucesso!');
        this.refreshLista();
      },
      error: (err: any) => {
        this.transporteSalvando = false;
        this.transporteErro     = err?.error?.erro ?? err?.message ?? 'Erro ao salvar transporte.';
      }
    });
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Modal Fluxo de Desmembramento
  // ══════════════════════════════════════════════════════════════════════════
  modalFluxoAberto       = false;
  fluxoNunota: number | null = null;
  fluxoCarregando        = false;
  fluxoErro              = '';
  fluxoNos: FluxoNo[]    = [];
  fluxoRaizes: FluxoNo[] = [];

  onSolicitarFluxoPedido(nunota: number): void {
    this.fluxoNunota      = nunota;
    this.fluxoErro        = '';
    this.fluxoNos         = [];
    this.fluxoRaizes      = [];
    this.modalFluxoAberto = true;
    this._carregarFluxo(nunota);
  }

  private _carregarFluxo(nunota: number): void {
    this.fluxoCarregando = true;
    this.gw.buscarFluxoDivisao(nunota).subscribe({
      next: (res: any) => {
        const body       = res?.responseBody ?? res;
        const lista: any[] = body?.fluxo ?? body?.nos ?? [];
        this.fluxoNos    = lista.map((n: any) => ({
          nunota:        Number(n.nunota ?? 0),
          codemp:        String(n.codemp ?? ''),
          dtmov:         n.dtmov  ?? '',
          status:        n.status ?? '',
          ehRaiz:        !!n.ehRaiz,
          ehSelecionada: Number(n.nunota) === nunota,
          filhos:        [],
        }));
        this.fluxoRaizes     = this._construirArvoreFluxo(lista, nunota);
        this.fluxoCarregando = false;
      },
      error: (err: any) => {
        this.fluxoErro       = err?.error?.erro ?? err?.message ?? 'Erro ao carregar fluxo.';
        this.fluxoCarregando = false;
      }
    });
  }

  private _construirArvoreFluxo(nos: any[], nunotaAtual: number): FluxoNo[] {
    const mapa = new Map<number, FluxoNo>();
    for (const n of nos) {
      mapa.set(Number(n.nunota), {
        nunota:        Number(n.nunota),
        codemp:        String(n.codemp ?? ''),
        dtmov:         n.dtmov  ?? '',
        status:        n.status ?? '',
        ehRaiz:        !!n.ehRaiz,
        ehSelecionada: Number(n.nunota) === nunotaAtual,
        filhos:        [],
      });
    }
    const raizes: FluxoNo[] = [];
    for (const n of nos) {
      const no = mapa.get(Number(n.nunota));
      if (!no) continue;
      const nunotaPai = n.nunotaPai != null ? Number(n.nunotaPai) : null;
      if (nunotaPai && mapa.has(nunotaPai)) {
        mapa.get(nunotaPai)!.filhos.push(no);
      } else {
        raizes.push(no);
      }
    }
    return raizes;
  }

  fecharModalFluxo(): void {
    if (this.fluxoCarregando) return;
    this.modalFluxoAberto = false;
  }

  /** Filtra a lista de pedidos para exibir apenas os que fazem parte deste fluxo. */
  filtrarVendasDoFluxo(): void {
    const nunotas = this.fluxoNos.map(n => n.nunota);
    const label   = `fluxo da venda #${this.fluxoNunota}`;
    this.modalFluxoAberto = false;
    this.activeView.set(this._vLista());
    // setTimeout: aguarda a lista ser montada (caso estivesse oculta) antes de aplicar
    setTimeout(() => this.listaAtiva?.aplicarFiltroFluxo(nunotas, label), 0);
  }

  fluxoNavegar(nunota: number, _codemp: string): void {
    this.modalFluxoAberto = false;
    this.pedidoEditando.set(nunota);
    this.activeView.set(this._vForm());
  }

  fluxoStatusClass(status: string): string {
    switch ((status ?? '').toUpperCase()) {
      case 'A': return 'fluxo-status-aberto';
      case 'L': return 'fluxo-status-liberado';
      case 'C': return 'fluxo-status-cancelado';
      default:  return 'fluxo-status-outro';
    }
  }

  fluxoStatusLabel(status: string): string {
    switch ((status ?? '').toUpperCase()) {
      case 'A': return 'Aberto';
      case 'L': return 'Liberado';
      case 'C': return 'Cancelado';
      default:  return status ?? '—';
    }
  }

  // ══════════════════════════════════════════════════════════════════════════
  // Modal Transferir Venda
  // ══════════════════════════════════════════════════════════════════════════
  modalTransferirAberto          = false;
  transferirNunota: number | null = null;
  transferirErro                 = '';
  empTransferirSelecionada: string | null = null;
  transferirCarregando           = false;
  transferirCodEmpOrigem         = '';

  /** Empresas 2 e 100 ficam fora da seleção de destino do Transferir (não podem ser destino de transferência). */
  get transferirEmpresasOpcoes(): EmpresaOpcao[] {
    return this.empresaState.opcoes.filter(e => e.codEmp !== '2' && e.codEmp !== '100');
  }

  onSolicitarTransferirPedido(ev: { nunota: number; codemp: number }): void {
    this.transferirNunota         = ev.nunota;
    this.transferirCodEmpOrigem   = String(ev.codemp);
    this.transferirErro           = '';
    this.empTransferirSelecionada = null;
    this.transferirCarregando     = false;
    this.modalTransferirAberto    = true;
    this.empresaState.carregar();
  }

  fecharModalTransferir(): void {
    if (this.transferirCarregando) return;
    this.modalTransferirAberto = false;
  }

  confirmarTransferir(): void {
    if (!this.empTransferirSelecionada || !this.transferirNunota) return;
    this.transferirCarregando = true;
    this.transferirErro       = '';
    this.gw.transferirPedidoVenda(this.transferirNunota, Number(this.empTransferirSelecionada)).subscribe({
      next: (res: any) => {
        this.transferirCarregando  = false;
        this.modalTransferirAberto = false;
        const body    = res?.responseBody ?? res;
        const nunota  = body?.nunota ?? this.transferirNunota;
        let msg = nunota ? `Venda #${nunota} transferida com sucesso!` : 'Venda transferida com sucesso!';
        if (body?.avisoTgfvar) msg += ' ⚠ ' + body.avisoTgfvar;
        this.mostrarToast(msg);
        // Troca para a empresa de destino e abre a lista com a venda selecionada
        if (this.empTransferirSelecionada && this.empTransferirSelecionada !== this.empresaState.selecionada) {
          this.empresaState.selecionada = this.empTransferirSelecionada;
        }
        this.activeView.set(this._vLista());
        if (nunota) {
          setTimeout(() => this.listaAtiva?.focarPedido(Number(nunota)), 400);
        }
      },
      error: (err: any) => {
        this.transferirCarregando = false;
        this.transferirErro       = err?.error?.erro ?? err?.message ?? 'Erro ao transferir venda.';
      }
    });
  }
}
